import { FullCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/copilot-definition';
import { UpsellDefinition } from 'libs/end-to-end/src/types/databases/copilots/upsell-definition';
import { UpsellType } from 'libs/end-to-end/src/types/databases/copilots/upsell-definition';
import { CopilotAutoMLConfiguration } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLDefaultCustomConfiguration } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLDefaultCustomConfigurationHuberLossDelta } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLDefaultCustomConfigurationNaColumnFilter } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLDefaultCustomConfigurationRobustnessPenalty } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLDefaultCustomConfigurationSelectedTopPercentile } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLConfigurationApproachType } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLConfigurationTaskType } from 'libs/end-to-end/src/copilot';
import { CopilotAutoMLConfigurationPreset } from 'libs/end-to-end/src/copilot';
import { CopilotType } from 'libs/end-to-end/src/copilot';
import { DataSetVersionsFull } from 'libs/end-to-end/src/types/databases/data-sets/data-set-version';
import { DatabaseRevision } from 'libs/end-to-end/src/types/databases/revisions/database-revision';
import { getDatabaseRevisionNameOrDefault } from 'libs/end-to-end/src/types/databases/revisions/database-revision';
import { DatabaseRevisionForPatch } from 'libs/end-to-end/src/types/databases/revisions/database-revision';
import { FilterSetDefinitions } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { DatabaseRevisionSchemaOptions } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-options';
import { PossibleDimensionSelection } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-options';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { FocusAreaDefinition } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';
import { OverviewPageConfiguration } from 'libs/end-to-end/src/overview-page-configuration';
import { OverviewPageConfigurationRequest } from 'libs/end-to-end/src/overview-page-configuration';
import { useParams } from 'react-router';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { useAsyncCallback } from 'apps/sigma2-ui/src/lib/hooks/useAsyncCallback';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { uiEnvironment } from 'apps/sigma2-ui/src/constants/environment';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { generateDimension } from 'libs/end-to-end/src/types/databases/dimensions/generate-dimensions';
import { z } from 'zod';
import { useSimpleWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleWritePattern';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { Database } from 'libs/end-to-end/src/types/databases/database';
import { LanguageName } from 'libs/end-to-end/src/language';
import { resolveLanguage } from 'libs/end-to-end/src/language';
import { getCustomFilterSets } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getDefaultFilterSetFilters } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { DatabaseRevisionSchemaWithoutFilters } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema';
import { HiringNotificationEmailSubjectSuffixTemplate } from 'libs/end-to-end/src/types/hiring-notification-sender/hiring-notification-email-subject-suffix-template';
import { RevisionStatus } from 'libs/end-to-end/src/types/databases/revisions/revision-status';
import { jsonParse } from 'libs/end-to-end/src/utils/utility/json-parse';
import { DynamicPipelineAnalysisConfiguration } from 'libs/end-to-end/src/dynamic-pipeline-analysis-configuration';
import { DynamicPipelineAnalysisPhase } from 'libs/end-to-end/src/dynamic-pipeline-analysis-configuration';
import { DatabaseRevisionSchemaValidationDimensionInsights } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { getInsightFormatOrDefault } from 'libs/end-to-end/src/insights';
import { getInsightWithReferenceFormatOrDefault } from 'libs/end-to-end/src/insights';
import { getShowBeforeEmpsOrAppsOrDefault } from 'libs/end-to-end/src/insights';
import { Insight } from 'libs/end-to-end/src/insights';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';
import { insight } from 'libs/end-to-end/src/factories/insight.factory';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { DefaultCalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { InsightImage } from 'apps/sigma2-ui/src/components/insights/InsightImage';
import React, {
  ReactNode,
  useCallback,
  useMemo,
  useState,
  useEffect,
  Fragment,
} from 'react';
import { ControlVariableDefinition } from 'libs/end-to-end/src/types/databases/controls/control-variable';
import { ControlVariablePlacesToHideOptions } from 'libs/end-to-end/src/types/databases/controls/control-variable-places-to-hide';
import { ControlVariablePlaceToHideValue } from 'libs/end-to-end/src/types/databases/controls/control-variable-places-to-hide';
import { DatabaseRevisionSchemaValidationFocusAreaError } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { FocusAreas } from 'libs/end-to-end/src/focus-area';
import { MetricDefinition } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { FocusAreaToolsDefinition } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';
import { inferFullToolsDefinitionWithDefaults } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';
import { AddSchemaSelectionComponent } from 'apps/sigma2-ui/src/data-wizard/lib/AddSchemaSelectionComponent';
import { getToolsDefinitionValidationErrors } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FocusAreaToolsPreviewValidationErrors } from 'apps/sigma2-ui/src/data-wizard/components/FocusAreaToolsPreviewValidationErrors';
import { ModelExperimentationTab } from 'apps/sigma2-ui/src/data-wizard/components/ModelExperimentationTab';
import { DatabaseRevisionSchemaValidationFilterError } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { FILTER_DEFINITION_DEFAULT_DISPLAY_TYPE } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FILTER_SET_DEFAULT_NAME } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterDefinitionDisplayType } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterDefinitionUsageType } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterDefinitionUsageTypes } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FilterSetDefinition } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { SchemaSelectionComponent } from 'apps/sigma2-ui/src/data-wizard/lib/SchemaSelectionComponent';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { buildDependencyGraph } from 'libs/end-to-end/src/utils/databases/filter-dependency-graph';
import { buildFilterFullDependencyGraphOrNullOnCircularReference } from 'libs/end-to-end/src/utils/databases/filter-dependency-graph';
import { checkIfColumnIsAllowedToBeFilter } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getPossibleFilterColumns } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TransformInsights } from 'libs/end-to-end/src/types/databases/transform/transform-insights';
import { FilterSelectBox } from 'apps/sigma2-ui/src/components/FilterBar';
import { OverviewPageNoIntelligenceConfiguration } from 'libs/end-to-end/src/overview-page-configuration';
import { OverviewPageConfigurationType } from 'libs/end-to-end/src/overview-page-configuration';
import { OverviewPageConfigurationTypes } from 'libs/end-to-end/src/overview-page-configuration';
import { OverviewPageCustomDashboardConfiguration } from 'libs/end-to-end/src/overview-page-configuration';
import { OverviewPageDefaultConfiguration } from 'libs/end-to-end/src/overview-page-configuration';
import { resolveFilterSet } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { TransformUniqueValuesByColumnItem } from 'libs/end-to-end/src/types/databases/transform/transform-insights';
import { CopilotTypes } from 'libs/end-to-end/src/copilot';
import { DatabaseRevisionSchemaValidationCopilotError } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { DataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';
import { FullHiringCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/hiring-copilot-definition';
import { FullPayBenchmarkingCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-benchmarking-copilot-definition';
import { FullPayCorrectionCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-correction-copilot-definition';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { DataSetVersionSelectorModal } from 'apps/sigma2-ui/src/data-wizard/components/DataSetVersionSelectorModal';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { DatabaseRevisionSchemaValidationUpsellError } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { UpsellTypes } from 'libs/end-to-end/src/types/databases/copilots/upsell-definition';
import { CalibrationFramings } from 'libs/end-to-end/src/calibration-framing';
import { replaceTextColor } from 'apps/sigma2-ui/src/components/ui/Typography';
import { DatabaseRevisionSchemaValidationMiscError } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-validation-result';
import { LanguageNames } from 'libs/end-to-end/src/language';
import { Switch } from 'apps/sigma2-ui/src/components/ui/Switch';
import { Heading } from 'apps/sigma2-ui/src/components/ui/Heading';
import { Color } from 'libs/end-to-end/src/types/branding/color';
import { Colors } from 'libs/end-to-end/src/types/branding/color';
import { Icon } from 'libs/end-to-end/src/types/branding/icon';
import { Icons } from 'libs/end-to-end/src/types/branding/icon';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { IconArrowDownSvg } from 'apps/sigma2-ui/src/components/svg/IconArrowDown';
import { ControlVariableDataTypes } from 'libs/end-to-end/src/types/databases/controls/control-variable-data-type';
import { ControlVariableTransformationTypes } from 'libs/end-to-end/src/types/databases/controls/control-variable-transformation-type';
import { numericalTraitDefinition } from 'libs/end-to-end/src/control-variable-definition-factory';
import { MetricDefinitionWhiteLabeling } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { MetricDefinitionCalibrationFramingValues } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-calibration-framing';
import { Dialog } from '@headlessui/react';
import { Popover } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import { preloadableMetricDefinitionWhiteLabels } from 'libs/end-to-end/src/types/databases/metrics/preloadable-white-labels';
import { PreloadableMetricDefinitionWhiteLabelTypeValues } from 'libs/end-to-end/src/types/databases/metrics/preloadable-white-labels';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import cn from 'classnames';
import { DeepDiveOverviewCard } from 'apps/sigma2-ui/src/components/DeepDiveOverviewCard';
import { convertMetricDefinitionToMyMetricDefinition } from 'libs/end-to-end/src/utils/databases/convert-metric-definition-to-my-metric-definition';
import { getListItemsForAllFilterSets } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { TranslationSelectionComponent } from 'apps/sigma2-ui/src/data-wizard/lib/TranslationSelectionComponent';
import { getPhrasesWithoutParams } from 'libs/end-to-end/src/phrase-utils';
import { ByMetricTrendsConfig } from 'libs/end-to-end/src/types/databases/trends/by-metric-trends-config';
import { ByMetricTrendsConfigurationComponent } from 'apps/sigma2-ui/src/data-wizard/components/ByMetricTrendsConfigurationComponent';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { NumberInput } from 'apps/sigma2-ui/src/components/ui/NumberInput';
import { validateCopilotAutoMLConfiguration } from 'libs/end-to-end/src/utils/databases/validateDatabaseSchema';
import { S2NumberField } from 'apps/sigma2-ui/src/filters-v2/components/S2NumberField';

export const DatabaseSchemaPageSelection = z.enum([
  'dimension',
  'filter',
  'focus-area',
  'copilot',
  'upsell',
  'overview-page-config',
  'pipeline-analysis-page-config',
  'misc',
  'model-experimentation',
]);
export type DatabaseSchemaPageSelection = z.infer<
  typeof DatabaseSchemaPageSelection
>;

export type DatabaseSchemaPageSelectionState =
  | {
      option: 'dimension';
      dimensions: DimensionDefinition[];
    }
  | {
      option: 'filter';
    }
  | {
      option: 'focus-area';
      focusAreas: FocusAreaDefinition[];
    }
  | {
      option: 'copilot';
      copilots: FullCopilotDefinition[];
    }
  | {
      option: 'upsell';
      upsells: UpsellDefinition[];
    }
  | {
      option: 'overview-page-config';
      configuration: OverviewPageConfiguration;
    }
  | {
      option: 'pipeline-analysis-page-config';
      configuration: DynamicPipelineAnalysisConfiguration[] | undefined;
    }
  | {
      option: 'misc';
    }
  | {
      option: 'model-experimentation';
    };

export interface DatabaseSchemaPageHook {
  selectedOrganizationId: string;
  selectedDatabaseId: string;
  selectedSchemaId: string;
  pageTitle: string;
  revisionName: string;
  setRevisionName: (name: string) => void;
  currentSelection: DatabaseSchemaPageSelection;
  setCurrentSelection: (selection: DatabaseSchemaPageSelection) => void;
  selectionOptions: {
    displayedValue: string;
    tabValue: DatabaseSchemaPageSelection;
    automationTag: string;
  }[];
  selectionState: DatabaseSchemaPageSelectionState;
  onSaveSchema: () => void;
  onPublishRevision: () => void;
  onLoadSchema: () => void;
  mostRecentErrorMessage: string[] | undefined;
  selectedUiNode: ReactNode;
  isRevisionHidden: boolean;
  setIsRevisionHidden: (visible: boolean) => void;
  isSaving: boolean;
  revisionStatus: RevisionStatus | null;
  currentSchemaToSave: DatabaseRevisionSchemaWithoutFilters;
  onUpdateSchemaLocally: (schema: DatabaseRevisionSchemaWithoutFilters) => void;
  loadedSchemaOptions: DatabaseRevisionSchemaOptions | null;
  revisionId: string;
  dataRequirementWarnings: string[];
}

// eslint-disable-next-line complexity
export const useDatabaseSchemaPage = (): DatabaseSchemaPageHook => {
  const { databaseId, organizationId, revisionId } = useParams();

  if (!databaseId || !revisionId || !organizationId) {
    throw new Error(
      'databaseId, revisionId, and organizationId are all required',
    );
  }

  const { myUser, userAuthenticatedApiCall } = useUser();

  const [currentSelection, setCurrentSelection] =
    useState<DatabaseSchemaPageSelection>('dimension');

  const [revisionStatus, setRevisionStatus] = useState<RevisionStatus | null>(
    null,
  );

  const [dimensionColumns, setDimensionColumns] = useState<
    DimensionDefinition[]
  >([]);

  const [filterSets, setFilterSets] = useState<FilterSetDefinitions>([]);

  const [focusAreaConfigs, setFocusAreaConfigs] = useState<
    FocusAreaDefinition[]
  >([]);

  const [copilotDefinitions, setCopilotDefinitions] = useState<
    FullCopilotDefinition[]
  >([]);

  const [upsellDefinitions, setUpsellDefinitions] = useState<
    UpsellDefinition[]
  >([]);

  const [calibrationFraming, setCalibrationFraming] =
    useState<CalibrationFraming | null>(null);

  const [hideFocusAreaSolutionsPage, setHideFocusAreaSolutionsPage] =
    useState(true);

  const [hideEmployeeLifecyclePage, sethideEmployeeLifecyclePage] =
    useState(true);

  const [showAllInsights, setShowAllInsights] = useState(false);
  const [showAIExplanations, setShowAIExplanations] = useState(false);
  const [showDynamicPipelineAnalysisPage, setShowDynamicPipelineAnalysisPage] =
    useState(false);
  const [showKeyFactors, setShowKeyFactors] = useState(false);
  const [showGeolocation, setShowGeolocation] = useState(false);
  const [showDashboardsPage, setShowDashboardsPage] = useState(false);
  const [showHeatmapAverages, setShowHeatmapAverages] = useState(false);
  const [showCustomChartTypes, setShowCustomChartTypes] = useState(false);
  const [showFobButtonInDashboardPage, setShowFobButtonInDashboardPage] =
    useState(false);

  const [
    sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
    setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
  ] = useState<boolean>(false);

  const [
    hiringNotificationEmailSubjectSuffixTemplate,
    setHiringNotificationEmailSubjectSuffixTemplate,
  ] = useState<HiringNotificationEmailSubjectSuffixTemplate>(
    HiringNotificationEmailSubjectSuffixTemplate.Values.NoSuffix,
  );

  const [
    forceHiringNotificationSummaryToOnlySendToThisEmail,
    setForceHiringNotificationSummaryToOnlySendToThisEmail,
  ] = useState<string | undefined>(undefined);

  const [
    numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
    setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
  ] = useState<number | undefined>(undefined);

  const [
    minReadinessRatingForHiringNotificationSummaryEmail,
    setMinReadinessRatingForHiringNotificationSummaryEmail,
  ] = useState<number | undefined>(undefined);

  const [
    additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
    setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
  ] = useState<string[] | undefined>(undefined);

  const [enableAtsWriteBack, setEnableAtsWriteBack] = useState<
    boolean | undefined
  >(undefined);

  const [overrideUploadSnapshotDate, setOverrideUploadSnapshotDate] =
    useState('');

  const [
    showNewDataIntelligenceDeepDivePage,
    setShowNewDataIntelligenceDeepDivePage,
  ] = useState(false);

  const [showProgressPage, setShowProgressPage] = useState(false);

  const [showSavedAnalysesPage, setShowSavedAnalysesPage] = useState(false);
  const [showRubricsPage, setShowRubricsPage] = useState(false);

  const [showDownloadMultiAnalysisButton, setShowDownloadMultiAnalysisButton] =
    useState(false);

  const [
    showDownloadSingleAnalysisButton,
    setShowDownloadSingleAnalysisButton,
  ] = useState(false);

  const [showExplorePage, setShowExplorePage] = useState(false);

  const [translationPhrasingCode, setTranslationPhrasingCode] = useState<
    LanguageName | undefined
  >(undefined);

  const [loadedSchemaOptions, setLoadedSchemaOptions] =
    useState<DatabaseRevisionSchemaOptions | null>(null);

  const [currentLoadedOverviewPageConfig, setCurrentLoadedOverviewPageConfig] =
    useState<OverviewPageConfiguration>({
      type: 'default',
    });

  const [currentLoadedPipelinePageConfig, setCurrentLoadedPipelinePageConfig] =
    useState<DynamicPipelineAnalysisConfiguration[] | undefined>([]);

  const [isSaving, setIsSaving] = useState(false);

  const [currentRevisionName, setCurrentRevisionName] = useState<string>('');

  const [isRevisionHidden, setIsRevisionHidden] = useState(false);

  const [useDisparityOnRay, setUseDisparityOnRay] = useState(false);

  const [useDisparityOnParquet, setUseDisparityOnParquet] = useState(false);

  const [useHeatmapOnRay, setUseHeatmapOnRay] = useState(false);

  const [useFAOnRay, setUseFAOnRay] = useState(false);

  const [byMetricTrendsConfiguration, setByMetricTrendsConfiguration] =
    useState<ByMetricTrendsConfig>({
      isEnabled: false,
    });

  const [copilotAutoMLConfiguration, setCopilotAutoMLConfiguration] = useState<
    CopilotAutoMLConfiguration | undefined
  >();

  const [showNewExplanations, setShowNewExplanations] = useState(false);

  const [enablePublicDashboards, setEnablePublicDashboards] = useState(false);
  const [showDashboardAISummaries, setShowDashboardAISummaries] =
    useState(false);

  const [showChatbot, setShowChatbot] = useState(false);

  const listDataSetVersionsFullPatternGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/data-set-versions-full`;
  }, [organizationId, databaseId]);

  const getOverviewPageConfigFullPatternGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${revisionId}/overview-page-configuration`;
  }, [organizationId, databaseId, revisionId]);

  const getDatabaseRevisionGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${revisionId}`;
  }, [organizationId, databaseId, revisionId]);

  const listDataSetVersionsFullPattern = useSimpleReadPattern({
    getUrlFn: listDataSetVersionsFullPatternGetUrlFn,
    canRead: true,
    responseSchema: DataSetVersionsFull,
  });

  const getOverviewPageConfigFullPattern = useSimpleReadPattern({
    getUrlFn: getOverviewPageConfigFullPatternGetUrlFn,
    canRead: true,
    responseSchema: OverviewPageConfiguration,
  });

  const saveOverviewPageConfigPattern = useSimpleWritePattern({
    getUrlFn: getOverviewPageConfigFullPatternGetUrlFn,
    canWrite: true,
    writeSchema: OverviewPageConfigurationRequest,
    responseSchema: EmptyObject,
  });

  const getDatabaseRevisionReadPattern = useSimpleReadPattern({
    getUrlFn: getDatabaseRevisionGetUrlFn,
    canRead: true,
    responseSchema: DatabaseRevision,
  });

  const getDatabaseByIdReadPattern = useSimpleDatabaseByIdReadPattern({
    organizationId,
    databaseId,
  });

  const [currentDatabase, setCurrentDatabase] = useState<Database | null>(null);

  useEffect(() => {
    if (getOverviewPageConfigFullPattern.status === 'done') {
      setCurrentLoadedOverviewPageConfig(
        getOverviewPageConfigFullPattern.entity,
      );
    } else {
      return;
    }
  }, [getOverviewPageConfigFullPattern]);

  const loadedDatabaseName = useMemo(() => {
    return getDatabaseByIdReadPattern.status === 'done'
      ? getDatabaseByIdReadPattern.entity.name
      : '';
  }, [getDatabaseByIdReadPattern]);

  const loadedRevision = useMemo(() => {
    return getDatabaseRevisionReadPattern.status === 'done'
      ? getDatabaseRevisionReadPattern.entity
      : null;
  }, [getDatabaseRevisionReadPattern]);

  useEffect(() => {
    if (loadedDatabaseName && loadedRevision) {
      setCurrentRevisionName(
        getDatabaseRevisionNameOrDefault({
          revision: loadedRevision,
          databaseName: loadedDatabaseName,
        }),
      );
      setIsRevisionHidden(loadedRevision.isHidden ?? false);

      setRevisionStatus(loadedRevision.revisionStatus);
    } else {
      return;
    }
  }, [loadedDatabaseName, loadedRevision]);

  useEffect(() => {
    if (getDatabaseByIdReadPattern.status === 'done') {
      setCurrentDatabase(getDatabaseByIdReadPattern.entity);
    } else {
      return;
    }
  }, [getDatabaseByIdReadPattern]);

  const selectionState = useMemo<DatabaseSchemaPageSelectionState>(() => {
    switch (currentSelection) {
      case 'dimension':
        return {
          option: 'dimension',
          dimensions: dimensionColumns,
        };
      case 'focus-area':
        return {
          option: 'focus-area',
          focusAreas: focusAreaConfigs,
        };
      case 'filter':
        return {
          option: 'filter',
        };
      case 'copilot':
        return {
          option: 'copilot',
          copilots: copilotDefinitions,
        };
      case 'upsell':
        return {
          option: 'upsell',
          upsells: upsellDefinitions,
        };
      case 'overview-page-config':
        return {
          option: 'overview-page-config',
          configuration: currentLoadedOverviewPageConfig,
        };
      case 'pipeline-analysis-page-config':
        return {
          option: 'pipeline-analysis-page-config',
          configuration: currentLoadedPipelinePageConfig,
        };
      case 'misc':
        return {
          option: 'misc',
        };
      case 'model-experimentation':
        return {
          option: 'model-experimentation',
        };
      default:
        throw guardExhaustive(currentSelection);
    }
  }, [
    currentSelection,
    dimensionColumns,
    focusAreaConfigs,
    copilotDefinitions,
    upsellDefinitions,
    currentLoadedOverviewPageConfig,
    currentLoadedPipelinePageConfig,
  ]);

  if (!databaseId || !revisionId || !organizationId) {
    throw new Error(
      'databaseId, revisionId, and organizationId are all required',
    );
  }

  const pageTitle = useMemo(() => {
    return 'Updating Schema for Database: ' + (currentDatabase?.name ?? 'N/A');
  }, [currentDatabase]);

  const addDimensionDefinition = useCallback(
    (possibleDimension: PossibleDimensionSelection) => {
      setDimensionColumns((columns) => [
        ...columns,
        generateDimension(possibleDimension),
      ]);
    },
    [],
  );

  const addFocusAreaDefinition = useCallback((focusArea: FocusArea) => {
    setFocusAreaConfigs((configs) => [
      ...configs,
      {
        focusArea: focusArea,
        controlVariables: [],
        metrics: [],
        performanceMetric: null,
      },
    ]);
  }, []);

  const addCopilotDefinition = useCallback((copilotType: CopilotType) => {
    setCopilotDefinitions((definitions) => [
      ...definitions,
      {
        copilotType,
      },
    ]);
  }, []);

  const addUpsellDefinition = useCallback((type: UpsellType) => {
    setUpsellDefinitions((definitions) => [
      ...definitions,
      {
        type,
      },
    ]);
  }, []);

  const updateDimensionColumnEntry = useCallback(
    (index: number, column: Partial<DimensionDefinition>) => {
      setDimensionColumns((columns) => {
        const newColumns = [...columns];
        newColumns[index] = { ...newColumns[index], ...column };
        return newColumns;
      });
    },
    [],
  );

  const updateFocusAreaColumnEntry = useCallback(
    (
      index: number,
      column: Partial<Omit<FocusAreaDefinition, 'focusArea'>>,
    ) => {
      setFocusAreaConfigs((configs) => {
        const newConfigs = [...configs];
        newConfigs[index] = { ...newConfigs[index], ...column };
        return newConfigs;
      });
    },
    [],
  );

  const updateCopilotColumnEntry = useCallback(
    (
      index: number,
      column: Partial<Omit<FullCopilotDefinition, 'copilotType'>>,
    ) => {
      setCopilotDefinitions((configs) => {
        const newConfigs = [...configs];
        newConfigs[index] = { ...newConfigs[index], ...column };
        return newConfigs;
      });
    },
    [],
  );

  const updateUpsellColumnEntry = useCallback(
    (index: number, column: Partial<Omit<UpsellDefinition, 'type'>>) => {
      setUpsellDefinitions((configs) => {
        const newConfigs = [...configs];
        newConfigs[index] = { ...newConfigs[index], ...column };
        return newConfigs;
      });
    },
    [],
  );

  const deleteColumnEntry = useCallback(
    (index: number) => {
      if (selectionState.option === 'dimension') {
        setDimensionColumns((columns) => {
          const newColumns = [...columns];
          newColumns.splice(index, 1);
          return newColumns;
        });
        return;
      } else if (selectionState.option === 'focus-area') {
        setFocusAreaConfigs((configs) => {
          const newConfigs = [...configs];
          newConfigs.splice(index, 1);
          return newConfigs;
        });
        return;
      } else if (selectionState.option === 'copilot') {
        setCopilotDefinitions((configs) => {
          const newDefinitions = [...configs];
          newDefinitions.splice(index, 1);
          return newDefinitions;
        });
        return;
      } else if (selectionState.option === 'upsell') {
        setUpsellDefinitions((configs) => {
          const newDefinitions = [...configs];
          newDefinitions.splice(index, 1);
          return newDefinitions;
        });
        return;
      } else if (
        selectionState.option === 'overview-page-config' ||
        selectionState.option === 'pipeline-analysis-page-config' ||
        selectionState.option === 'misc' ||
        selectionState.option === 'filter' ||
        selectionState.option === 'model-experimentation'
      ) {
        // Not relevant.
      } else {
        throw guardExhaustive(selectionState);
      }
    },
    [selectionState],
  );

  const dimensionPageHook = useDatabaseSchemaDimensionsPage({
    columns: dimensionColumns,
    updateColumnEntry: updateDimensionColumnEntry,
    deleteColumnEntry: deleteColumnEntry,
    possibleDimensionSelections:
      loadedSchemaOptions?.possibleDimensionSelections ?? [],
    possibleRawCorrespondingSelections:
      loadedSchemaOptions?.possibleAnySelections ?? [],
    insights: loadedSchemaOptions?.validations.dimensions ?? [],
    addColumnEntry: addDimensionDefinition,
  });

  const filterHook = useDatabaseSchemaFilterPage({
    filterSets,
    onUpdateFilterSets: setFilterSets,
    uniqueValuesByColumn: loadedSchemaOptions?.uniqueValuesByColumn ?? [],
    filterErrors: loadedSchemaOptions?.validations.filters ?? [],
    numericColumns: loadedSchemaOptions?.numericColumns ?? {},
    dateColumns: loadedSchemaOptions?.dateColumns ?? {},
  });

  const focusAreaPageHook = useDatabaseSchemaFocusAreaPage({
    focusAreaConfigs: focusAreaConfigs,
    updateColumnEntry: updateFocusAreaColumnEntry,
    deleteColumnEntry: deleteColumnEntry,
    addFAEntry: addFocusAreaDefinition,
    possibleControlVariableSelections:
      loadedSchemaOptions?.possibleControlVariableSelections ?? [],
    possibleMetricSelections:
      loadedSchemaOptions?.possibleMetricSelections ?? [],
    focusAreaErrors: loadedSchemaOptions?.validations.focusAreas ?? [],
    filterSets,
    dataIntelligenceDeepDiveIsEnabled: showNewDataIntelligenceDeepDivePage,
    calibrationFraming: calibrationFraming ?? 'bias',
    uniqueValuesByColumn: loadedSchemaOptions?.uniqueValuesByColumn ?? [],
    numericColumns: loadedSchemaOptions?.numericColumns ?? {},
    dateColumns: loadedSchemaOptions?.dateColumns ?? {},
  });

  const copilotPageHook = useDatabaseSchemaCopilotPage({
    copilotDefinitions,
    updateColumnEntry: updateCopilotColumnEntry,
    deleteColumnEntry: deleteColumnEntry,
    addCopilotEntry: addCopilotDefinition,
    copilotErrors: loadedSchemaOptions?.validations.copilots ?? [],
    listDataSetVersionsFullPattern,
    organizationId,
    copilotAutoMLConfiguration,
    setCopilotAutoMLConfiguration,
  });

  const upsellPageHook = useDatabaseSchemaUpsellPage({
    upsellDefinitions,
    updateColumnEntry: updateUpsellColumnEntry,
    deleteColumnEntry: deleteColumnEntry,
    addUpsellEntry: addUpsellDefinition,
    upsellErrors: loadedSchemaOptions?.validations.upsells ?? [],
    organizationId,
  });

  const overviewPageConfigHook = useDatabaseSchemaOverviewPageConfigPage({
    currentConfig: currentLoadedOverviewPageConfig,
    setCurrentConfig: setCurrentLoadedOverviewPageConfig,
    filterSets,
    focusAreaDefinitions: focusAreaConfigs,
    uniqueValuesByColumn: loadedSchemaOptions?.uniqueValuesByColumn ?? [],
  });

  const pipelineAnalysisConfigHook =
    useDatabaseSchemaDynamicPipelineAnalysisConfigPage({
      pipelineConfigs: currentLoadedPipelinePageConfig ?? [],
      onUpdatePipelineConfigs: setCurrentLoadedPipelinePageConfig,
      focusAreaDefinitions: focusAreaConfigs,
      filterSets,
    });

  const metricDefinitions: MetricDefinition[] = useMemo(() => {
    return focusAreaConfigs.flatMap((focusAreaConfig) => {
      return focusAreaConfig.metrics;
    });
  }, [focusAreaConfigs]);

  const miscPageHook = useDatabaseSchemaMiscPage({
    possibleDimensionColumns: (
      loadedSchemaOptions?.possibleDimensionSelections ?? []
    ).map((x) => x.name),
    possibleDateColumns: Object.keys(loadedSchemaOptions?.dateColumns ?? {}),
    metricDefinitions,
    calibrationFraming,
    setCalibrationFraming,
    showAllInsights,
    setShowAllInsights,
    showKeyFactors,
    setShowKeyFactors,
    showGeolocation,
    setShowGeolocation,
    sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
    setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
    enableAtsWriteBack,
    setEnableAtsWriteBack,
    hiringNotificationEmailSubjectSuffixTemplate,
    setHiringNotificationEmailSubjectSuffixTemplate,
    forceHiringNotificationSummaryToOnlySendToThisEmail,
    setForceHiringNotificationSummaryToOnlySendToThisEmail,
    numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
    setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
    minReadinessRatingForHiringNotificationSummaryEmail,
    setMinReadinessRatingForHiringNotificationSummaryEmail,
    additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
    setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
    showNewDataIntelligenceDeepDivePage,
    setShowNewDataIntelligenceDeepDivePage,
    showProgressPage,
    setShowProgressPage,
    showSavedAnalysesPage,
    setShowSavedAnalysesPage,
    showRubricsPage,
    setShowRubricsPage,
    showDownloadMultiAnalysisButton,
    setShowDownloadMultiAnalysisButton,
    showDownloadSingleAnalysisButton,
    setShowDownloadSingleAnalysisButton,
    showExplorePage,
    setShowExplorePage,
    setOverrideUploadSnapshotDate,
    overrideUploadSnapshotDate,
    hideEmployeeLifecyclePage,
    sethideEmployeeLifecyclePage,
    hideFocusAreaSolutionsPage,
    setHideFocusAreaSolutionsPage,
    miscErrors: loadedSchemaOptions?.validations.miscs ?? [],
    translationPhrasingCode,
    setTranslationPhrasingCode,
    showAIExplanations,
    setShowAIExplanations,
    showDynamicPipelineAnalysisPage,
    setShowDynamicPipelineAnalysisPage,
    showDashboardsPage,
    setShowDashboardsPage,
    showCustomChartTypes,
    setShowCustomChartTypes,
    showFobButtonInDashboardPage,
    setShowFobButtonInDashboardPage,
    showHeatmapAverages,
    setShowHeatmapAverages,
    useDisparityOnRay,
    setUseDisparityOnRay,
    useDisparityOnParquet,
    setUseDisparityOnParquet,
    useHeatmapOnRay,
    setUseHeatmapOnRay,
    useFAOnRay,
    setUseFAOnRay,
    byMetricTrendsConfiguration,
    setByMetricTrendsConfiguration,
    showNewExplanations,
    setShowNewExplanations,
    enablePublicDashboards,
    setEnablePublicDashboards,
    showDashboardAISummaries,
    setShowDashboardAISummaries,
    showChatbot,
    setShowChatbot,
  });

  const modelExperimentationPageHook = useMemo(
    () => (
      <ModelExperimentationTab
        uniqueValuesByColumn={loadedSchemaOptions?.uniqueValuesByColumn ?? []}
        revisionId={revisionId}
        organizationId={organizationId}
        databaseId={databaseId}
        possibleMetricSelections={
          loadedSchemaOptions?.possibleMetricSelections ?? []
        }
        filterSets={filterSets}
        focusAreaDefinitions={loadedSchemaOptions?.focusAreaDefinitions ?? []}
      />
    ),
    [
      loadedSchemaOptions?.uniqueValuesByColumn,
      loadedSchemaOptions?.possibleMetricSelections,
      loadedSchemaOptions?.focusAreaDefinitions,
      revisionId,
      organizationId,
      databaseId,
      filterSets,
    ],
  );

  const selectedUiNode = useMemo<ReactNode>(() => {
    switch (currentSelection) {
      case 'dimension':
        return dimensionPageHook;
      case 'focus-area':
        return focusAreaPageHook;
      case 'filter':
        return filterHook;
      case 'copilot':
        return copilotPageHook;
      case 'upsell':
        return upsellPageHook;
      case 'overview-page-config':
        return overviewPageConfigHook;
      case 'pipeline-analysis-page-config':
        return pipelineAnalysisConfigHook;
      case 'misc':
        return miscPageHook;
      case 'model-experimentation':
        return modelExperimentationPageHook;
      default:
        throw guardExhaustive(currentSelection);
    }
  }, [
    currentSelection,
    dimensionPageHook,
    focusAreaPageHook,
    filterHook,
    copilotPageHook,
    upsellPageHook,
    overviewPageConfigHook,
    pipelineAnalysisConfigHook,
    miscPageHook,
    modelExperimentationPageHook,
  ]);

  const [mostRecentErrorMessage, setMostRecentErrorMessage] = useState<
    string[] | undefined
  >(undefined);

  const onUpdateSchemaLocally = useCallback(
    // eslint-disable-next-line complexity
    (schema: DatabaseRevisionSchemaWithoutFilters) => {
      setDimensionColumns(schema.dimensions);
      setFocusAreaConfigs(schema.focusAreas);
      setFilterSets(schema.filterSets ?? []);
      setCopilotDefinitions(schema.copilots ?? []);
      setUpsellDefinitions(schema.upsells ?? []);
      setCalibrationFraming(schema.calibrationFraming ?? null);
      setShowAllInsights(schema.showAllInsights ?? false);
      setShowAIExplanations(schema.showAIExplanations ?? false);
      setShowDynamicPipelineAnalysisPage(
        schema.showDynamicPipelineAnalysisPage ?? false,
      );
      setShowKeyFactors(schema.showKeyFactors ?? false);
      setShowGeolocation(schema.showGeolocation ?? false);
      setShowDashboardsPage(schema.showDashboardsPage ?? false);
      setShowCustomChartTypes(schema.showCustomChartTypes ?? false);
      setShowFobButtonInDashboardPage(
        schema.showFobButtonInDashboardPage ?? false,
      );
      setShowHeatmapAverages(schema.showHeatmapAverages ?? false);
      setHideFocusAreaSolutionsPage(schema.hideFocusAreaSolutionsPage ?? false);
      sethideEmployeeLifecyclePage(schema.hideEmployeeLifecyclePage ?? false);
      setOverrideUploadSnapshotDate(schema.overrideUploadSnapshotDate ?? '');
      setShowNewDataIntelligenceDeepDivePage(
        schema.showNewDataIntelligenceDeepDivePage ?? false,
      );
      setShowProgressPage(schema.showProgressPage ?? false);
      setShowSavedAnalysesPage(schema.showSavedAnalysesPage ?? false);
      setShowRubricsPage(schema.showRubricsPage ?? false);
      setShowDownloadMultiAnalysisButton(
        schema.showDownloadMultiAnalysisButton ?? false,
      );
      setShowDownloadSingleAnalysisButton(
        schema.showDownloadSingleAnalysisButton ?? false,
      );
      setShowExplorePage(schema.showExplorePage ?? false);
      setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis(
        schema.sendHiringNotificationSummaryEmailAfterTopLevelAnalysis ?? false,
      );
      setHiringNotificationEmailSubjectSuffixTemplate(
        schema.hiringNotificationEmailSubjectSuffixTemplate ??
          HiringNotificationEmailSubjectSuffixTemplate.Values.NoSuffix,
      );
      setForceHiringNotificationSummaryToOnlySendToThisEmail(
        schema.forceHiringNotificationSummaryToOnlySendToThisEmail,
      );
      setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo(
        schema.additionalEmailsToSendAllHiringNotificationSummaryEmailsTo ?? [],
      );
      setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail(
        schema.numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
      );
      setMinReadinessRatingForHiringNotificationSummaryEmail(
        schema.minReadinessRatingForHiringNotificationSummaryEmail,
      );
      setEnableAtsWriteBack(schema.enableAtsWriteBack);
      setTranslationPhrasingCode(
        resolveLanguage(schema.translationPhrasingCode),
      );
      setCurrentLoadedPipelinePageConfig(schema.pipelineAnalysisConfiguration);
      setUseDisparityOnRay(schema.useDisparityOnRay ?? false);
      setUseDisparityOnParquet(schema.useDisparityOnParquet ?? false);
      setUseHeatmapOnRay(schema.useHeatmapOnRay ?? false);
      setUseFAOnRay(schema.useFAOnRay ?? false);
      setByMetricTrendsConfiguration(
        schema.byMetricTrendsConfiguration ?? {
          isEnabled: false,
        },
      );
      setCopilotAutoMLConfiguration(schema.copilotAutoMLConfiguration);
      setShowNewExplanations(schema.showNewExplanations ?? false);
      setEnablePublicDashboards(schema.enablePublicDashboards ?? false);
      setShowDashboardAISummaries(schema.showDashboardAISummaries ?? false);
      setShowChatbot(schema.showChatbot ?? false);
    },
    [],
  );

  const onSave = useAsyncCallback(
    // eslint-disable-next-line complexity
    async (isAlive) => {
      if (!isAlive() || isSaving) {
        return;
      }

      if (!myUser) {
        return;
      }

      if (currentRevisionName.length === 0) {
        setMostRecentErrorMessage(['Please provide a name for the revision']);
        return;
      }

      setMostRecentErrorMessage(undefined);
      setIsSaving(true);

      const schemaToSave: DatabaseRevisionForPatch = {
        selectedSchema: {
          dimensions: dimensionColumns,
          focusAreas: focusAreaConfigs,
          // Here, we have to send the database revision decomposed into default filters and custom filter sets.
          filters: getDefaultFilterSetFilters(filterSets),
          filterSets: getCustomFilterSets(filterSets),
          copilots: copilotDefinitions,
          upsells: upsellDefinitions,
          calibrationFraming: calibrationFraming ?? undefined,
          showAllInsights,
          showAIExplanations,
          showDynamicPipelineAnalysisPage,
          showKeyFactors,
          showGeolocation,
          showDashboardsPage,
          showCustomChartTypes,
          showFobButtonInDashboardPage,
          showHeatmapAverages,
          sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
          hiringNotificationEmailSubjectSuffixTemplate,
          forceHiringNotificationSummaryToOnlySendToThisEmail,
          numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
          minReadinessRatingForHiringNotificationSummaryEmail,
          additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
          enableAtsWriteBack,
          hideFocusAreaSolutionsPage,
          hideEmployeeLifecyclePage,
          overrideUploadSnapshotDate,
          showNewDataIntelligenceDeepDivePage,
          showProgressPage,
          showSavedAnalysesPage,
          showRubricsPage,
          showDownloadMultiAnalysisButton,
          showDownloadSingleAnalysisButton,
          showExplorePage,
          translationPhrasingCode,
          pipelineAnalysisConfiguration: currentLoadedPipelinePageConfig,
          useDisparityOnRay,
          useDisparityOnParquet,
          useHeatmapOnRay,
          useFAOnRay,
          byMetricTrendsConfiguration: byMetricTrendsConfiguration,
          copilotAutoMLConfiguration,
          showNewExplanations,
          enablePublicDashboards,
          showDashboardAISummaries,
          showChatbot,
        },
        name: currentRevisionName,
        isHidden: isRevisionHidden,
      };

      const response = await userAuthenticatedApiCall({
        url: `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${revisionId}`,
        requestOptions: {
          method: 'PATCH',
          body: JSON.stringify(schemaToSave),
        },
        responseSchema: EmptyObject,
      });

      if (!response) {
        setMostRecentErrorMessage(['Failed to save schema']);
        setIsSaving(false);
        return;
      }

      if (response.resultType === 'err') {
        const error = response.error;
        if ('errorReason' in error && typeof error.errorReason === 'string') {
          const parsedArray = jsonParse(error.errorReason, z.array(z.string()));
          if (parsedArray.resultType === 'ok') {
            setMostRecentErrorMessage(parsedArray.value);
          } else {
            setMostRecentErrorMessage(['Failed to save schema']);
          }
        } else {
          setMostRecentErrorMessage(['Failed to save schema']);
        }
        setIsSaving(false);
        return;
      }

      if (saveOverviewPageConfigPattern.status === 'saving') {
        setIsSaving(false);
        return;
      }

      saveOverviewPageConfigPattern.saveEntity({
        configuration: currentLoadedOverviewPageConfig,
      });
      setIsSaving(false);
    },
    [
      isSaving,
      myUser,
      currentRevisionName,
      dimensionColumns,
      focusAreaConfigs,
      filterSets,
      copilotDefinitions,
      upsellDefinitions,
      calibrationFraming,
      showAllInsights,
      showAIExplanations,
      showDynamicPipelineAnalysisPage,
      showKeyFactors,
      showGeolocation,
      showDashboardsPage,
      showCustomChartTypes,
      showFobButtonInDashboardPage,
      showHeatmapAverages,
      sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
      hiringNotificationEmailSubjectSuffixTemplate,
      forceHiringNotificationSummaryToOnlySendToThisEmail,
      numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
      minReadinessRatingForHiringNotificationSummaryEmail,
      additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
      enableAtsWriteBack,
      hideFocusAreaSolutionsPage,
      hideEmployeeLifecyclePage,
      overrideUploadSnapshotDate,
      showNewDataIntelligenceDeepDivePage,
      showProgressPage,
      showSavedAnalysesPage,
      showRubricsPage,
      showDownloadMultiAnalysisButton,
      showDownloadSingleAnalysisButton,
      showExplorePage,
      translationPhrasingCode,
      currentLoadedPipelinePageConfig,
      isRevisionHidden,
      userAuthenticatedApiCall,
      organizationId,
      databaseId,
      revisionId,
      saveOverviewPageConfigPattern,
      currentLoadedOverviewPageConfig,
      useDisparityOnRay,
      useDisparityOnParquet,
      useHeatmapOnRay,
      useFAOnRay,
      byMetricTrendsConfiguration,
      copilotAutoMLConfiguration,
      showNewExplanations,
      enablePublicDashboards,
      showDashboardAISummaries,
      showChatbot,
    ],
  );

  const currentSchemaToSave: DatabaseRevisionSchemaWithoutFilters =
    useMemo(() => {
      return {
        dimensions: dimensionColumns,
        focusAreas: focusAreaConfigs,
        // Here, we have to send the database revision decomposed into default filters and custom filter sets.
        filterSets: filterSets,
        copilots: copilotDefinitions,
        upsells: upsellDefinitions,
        calibrationFraming: calibrationFraming ?? undefined,
        showAllInsights,
        showAIExplanations,
        showDynamicPipelineAnalysisPage,
        showKeyFactors,
        showGeolocation,
        showDashboardsPage,
        showCustomChartTypes,
        showFobButtonInDashboardPage,
        showHeatmapAverages,
        hideFocusAreaSolutionsPage,
        hideEmployeeLifecyclePage,
        overrideUploadSnapshotDate,
        showNewDataIntelligenceDeepDivePage,
        showProgressPage,
        showSavedAnalysesPage,
        showRubricsPage,
        showDownloadMultiAnalysisButton,
        showDownloadSingleAnalysisButton,
        showExplorePage,
        sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
        hiringNotificationEmailSubjectSuffixTemplate,
        forceHiringNotificationSummaryToOnlySendToThisEmail,
        minReadinessRatingForHiringNotificationSummaryEmail,
        additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
        numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
        enableAtsWriteBack,
        translationPhrasingCode,
        useDisparityOnRay,
        useDisparityOnParquet,
        useHeatmapOnRay,
        useFAOnRay,
        copilotAutoMLConfiguration,
        showNewExplanations,
        enablePublicDashboards,
        showDashboardAISummaries,
        showChatbot,
      };
    }, [
      calibrationFraming,
      copilotDefinitions,
      dimensionColumns,
      filterSets,
      focusAreaConfigs,
      hideEmployeeLifecyclePage,
      hideFocusAreaSolutionsPage,
      overrideUploadSnapshotDate,
      showAIExplanations,
      showDynamicPipelineAnalysisPage,
      showAllInsights,
      showNewDataIntelligenceDeepDivePage,
      showProgressPage,
      showSavedAnalysesPage,
      showRubricsPage,
      showDownloadMultiAnalysisButton,
      showDownloadSingleAnalysisButton,
      showExplorePage,
      showKeyFactors,
      showGeolocation,
      showDashboardsPage,
      showHeatmapAverages,
      showCustomChartTypes,
      showFobButtonInDashboardPage,
      translationPhrasingCode,
      upsellDefinitions,
      sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
      hiringNotificationEmailSubjectSuffixTemplate,
      forceHiringNotificationSummaryToOnlySendToThisEmail,
      minReadinessRatingForHiringNotificationSummaryEmail,
      additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
      numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
      enableAtsWriteBack,
      useDisparityOnRay,
      useDisparityOnParquet,
      useHeatmapOnRay,
      useFAOnRay,
      copilotAutoMLConfiguration,
      showNewExplanations,
      enablePublicDashboards,
      showDashboardAISummaries,
      showChatbot,
    ]);

  const onPublish = useAsyncCallback(
    async (isAlive) => {
      if (!isAlive() || isSaving) {
        return;
      }

      if (!myUser) {
        return;
      }

      //Reset the error message when we press save again
      setMostRecentErrorMessage(undefined);
      setIsSaving(true);

      const response = await userAuthenticatedApiCall({
        url: `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${revisionId}/publish`,
        requestOptions: {
          method: 'POST',
          body: JSON.stringify({
            automaticallyStartTopLevelAnalysis: true,
          }),
        },
        responseSchema: EmptyObject,
      });

      if (!response) {
        setMostRecentErrorMessage(['Failed to save schema']);
      } else if (response.resultType === 'err') {
        const error = response.error;
        console.log(error);
        if ('errorReason' in error && typeof error.errorReason === 'string') {
          const parsedArray = jsonParse(error.errorReason, z.array(z.string()));
          if (parsedArray.resultType === 'ok') {
            setMostRecentErrorMessage(parsedArray.value);
          } else {
            setMostRecentErrorMessage(['Failed to save schema']);
          }
        } else {
          setMostRecentErrorMessage(['Failed to save schema']);
        }
      }

      setIsSaving(false);

      if (getDatabaseRevisionReadPattern.status === 'done') {
        getDatabaseRevisionReadPattern.reloadEntity();
      }
    },
    [
      isSaving,
      myUser,
      userAuthenticatedApiCall,
      organizationId,
      databaseId,
      revisionId,
      getDatabaseRevisionReadPattern,
    ],
  );

  const onLoad = useAsyncCallback(
    async (isAlive) => {
      if (!isAlive()) {
        return;
      }

      if (!myUser) {
        return;
      }

      const response = await userAuthenticatedApiCall({
        url: `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${revisionId}/schema-options`,
        requestOptions: {
          method: 'GET',
        },
        responseSchema: DatabaseRevisionSchemaOptions,
      });

      if (!response) {
        setMostRecentErrorMessage(['Failed to load schema']);
        return;
      }

      if (response.resultType === 'err') {
        setMostRecentErrorMessage(['Failed to load schema']);
        return;
      }
      const schema: DatabaseRevisionSchemaWithoutFilters = {
        dimensions: response.value.dimensionDefinitions,
        focusAreas: response.value.focusAreaDefinitions,
        filterSets: response.value.filterSets,
        copilots: response.value.copilotDefinitions,
        upsells: response.value.upsellDefinitions,
        calibrationFraming: response.value.calibrationFraming,
        showAllInsights: response.value.showAllInsights,
        showAIExplanations: response.value.showAIExplanations,
        showDynamicPipelineAnalysisPage:
          response.value.showDynamicPipelineAnalysisPage,
        showKeyFactors: !!response.value.showKeyFactors,
        showGeolocation: !!response.value.showGeolocation,
        showDashboardsPage: !!response.value.showDashboardsPage,
        showCustomChartTypes: !!response.value.showCustomChartTypes,
        showFobButtonInDashboardPage:
          !!response.value.showFobButtonInDashboardPage,
        showHeatmapAverages: !!response.value.showHeatmapAverages,
        hideEmployeeLifecyclePage: response.value.hideEmployeeLifecyclePage,
        hideFocusAreaSolutionsPage: response.value.hideFocusAreaSolutionsPage,
        overrideUploadSnapshotDate: response.value.overrideUploadSnapshotDate,
        showNewDataIntelligenceDeepDivePage:
          response.value.showNewDataIntelligenceDeepDivePage,
        showProgressPage: response.value.showProgressPage,
        showSavedAnalysesPage: response.value.showSavedAnalysesPage,
        showRubricsPage: response.value.showRubricsPage,
        showDownloadMultiAnalysisButton:
          response.value.showDownloadMultiAnalysisButton,
        showDownloadSingleAnalysisButton:
          response.value.showDownloadSingleAnalysisButton,
        showExplorePage: response.value.showExplorePage,
        sendHiringNotificationSummaryEmailAfterTopLevelAnalysis:
          response.value
            .sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
        hiringNotificationEmailSubjectSuffixTemplate:
          response.value.hiringNotificationEmailSubjectSuffixTemplate,
        forceHiringNotificationSummaryToOnlySendToThisEmail:
          response.value.forceHiringNotificationSummaryToOnlySendToThisEmail,
        numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail:
          response.value
            .numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
        minReadinessRatingForHiringNotificationSummaryEmail:
          response.value.minReadinessRatingForHiringNotificationSummaryEmail,
        additionalEmailsToSendAllHiringNotificationSummaryEmailsTo:
          response.value
            .additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
        enableAtsWriteBack: response.value.enableAtsWriteBack,
        translationPhrasingCode: resolveLanguage(
          response.value.translationPhrasingCode,
        ),
        pipelineAnalysisConfiguration:
          response.value.pipelineAnalysisConfiguration,
        useDisparityOnRay: response.value.useDisparityOnRay,
        useDisparityOnParquet: response.value.useDisparityOnParquet,
        useHeatmapOnRay: response.value.useHeatmapOnRay,
        useFAOnRay: response.value.useFAOnRay,
        byMetricTrendsConfiguration: response.value.byMetricTrendsConfiguration,
        copilotAutoMLConfiguration: response.value.copilotAutoMLConfiguration,
        showNewExplanations: response.value.showNewExplanations,
        enablePublicDashboards: response.value.enablePublicDashboards,
        showDashboardAISummaries: response.value.showDashboardAISummaries,
        showChatbot: response.value.showChatbot,
      };

      onUpdateSchemaLocally(schema);

      setLoadedSchemaOptions(response.value);
    },
    [
      databaseId,
      myUser,
      onUpdateSchemaLocally,
      organizationId,
      revisionId,
      userAuthenticatedApiCall,
    ],
  );

  const dataRequirementWarnings: string[] = useMemo(() => {
    if (!loadedSchemaOptions) {
      return [];
    }

    const requiredNumericColumns = ['job_level'];

    const warnings: string[] = [];
    const numericKeys = Object.keys(loadedSchemaOptions.numericColumns ?? {});

    for (const requiredNumericColumn of requiredNumericColumns) {
      if (numericKeys.includes(requiredNumericColumn)) {
        continue;
      }

      warnings.push(
        `Column '${requiredNumericColumn}' must be present and numeric for data requirements.`,
      );
    }

    const requiredAnyColumns = [
      'department',
      'location',
      'managerid',
      'manager_race',
      'manager_gender',
      'attrition',
      'promotion',
      'hire',
      'job_title',
      'job_level',
      'entry_date',
      'leave_date',
      'employeeid',
      'applicantid',
      'year',
      'entry_year',
      'leave_year',
    ];

    for (const requiredAnyColumn of requiredAnyColumns) {
      if (
        loadedSchemaOptions.possibleAnySelections.includes(requiredAnyColumn)
      ) {
        continue;
      }
      warnings.push(
        `Column '${requiredAnyColumn}' is required for data requirements.`,
      );
    }

    for (const focusAreaConfig of focusAreaConfigs) {
      for (const controlVar of focusAreaConfig.controlVariables) {
        const shouldLikelyBeNumeric = Boolean(
          loadedSchemaOptions.numericColumns?.[controlVar.columnHeaderValue],
        );

        if (controlVar.dataType !== 'numeric' && shouldLikelyBeNumeric) {
          warnings.push(
            `Focus area '${focusAreaConfig.focusArea}' control variable '${controlVar.columnHeaderValue}' is configured as a categorical control variable but appears to have numeric values.`,
          );
        }
      }
    }

    return warnings;
  }, [loadedSchemaOptions, focusAreaConfigs]);

  return useMemo(() => {
    const selectionOptions: {
      displayedValue: string;
      tabValue: DatabaseSchemaPageSelection;
      automationTag: string;
    }[] = [
      {
        displayedValue: 'Dimensions',
        tabValue: 'dimension',
        automationTag: 'dimension',
      },
      {
        displayedValue: 'Filters',
        tabValue: 'filter',
        automationTag: 'filter',
      },
      {
        displayedValue: 'Focus Areas',
        tabValue: 'focus-area',
        automationTag: 'focus-area',
      },
      {
        displayedValue: 'Copilots',
        tabValue: 'copilot',
        automationTag: 'copilot',
      },
      {
        displayedValue: 'Upsells',
        tabValue: 'upsell',
        automationTag: 'upsell',
      },
      {
        displayedValue: 'Overview Page Config',
        tabValue: 'overview-page-config',
        automationTag: 'overview-page-config',
      },
      {
        displayedValue: 'Pipeline Analysis Page Config',
        tabValue: 'pipeline-analysis-page-config',
        automationTag: 'pipeline-analysis-page-config',
      },
      {
        displayedValue: 'Misc',
        tabValue: 'misc',
        automationTag: 'misc',
      },
      {
        displayedValue: 'Model Experimentation',
        tabValue: 'model-experimentation',
        automationTag: 'model-experimentation',
      },
    ];

    return {
      selectedDatabaseId: databaseId,
      selectedSchemaId: revisionId,
      selectedOrganizationId: organizationId,
      pageTitle,
      currentSelection,
      setCurrentSelection,
      selectionState,
      selectionOptions,
      onSaveSchema: onSave,
      onLoadSchema: onLoad,
      onPublishRevision: onPublish,
      mostRecentErrorMessage,
      selectedUiNode,
      isSaving,
      revisionName: currentRevisionName,
      setRevisionName: setCurrentRevisionName,
      isRevisionHidden,
      setIsRevisionHidden,
      currentSchemaToSave,
      onUpdateSchemaLocally,
      revisionStatus,
      loadedSchemaOptions,
      revisionId,
      dataRequirementWarnings,
    };
  }, [
    databaseId,
    revisionId,
    organizationId,
    pageTitle,
    currentSelection,
    selectionState,
    onSave,
    onLoad,
    onPublish,
    mostRecentErrorMessage,
    selectedUiNode,
    isSaving,
    currentRevisionName,
    isRevisionHidden,
    currentSchemaToSave,
    onUpdateSchemaLocally,
    revisionStatus,
    loadedSchemaOptions,
    dataRequirementWarnings,
  ]);
};

export const useDatabaseSchemaDimensionsPage = ({
  columns,
  possibleDimensionSelections,
  possibleRawCorrespondingSelections,
  updateColumnEntry,
  deleteColumnEntry,
  addColumnEntry,
  insights,
}: {
  columns: DimensionDefinition[];
  possibleDimensionSelections: PossibleDimensionSelection[];
  possibleRawCorrespondingSelections: string[];
  updateColumnEntry: (
    index: number,
    column: Partial<DimensionDefinition>,
  ) => void;
  deleteColumnEntry: (index: number) => void;
  addColumnEntry: (possibleDimension: PossibleDimensionSelection) => void;
  insights: DatabaseRevisionSchemaValidationDimensionInsights[];
}): React.ReactNode => {
  const [selectedColumnName, setSelectedColumnName] = useState<string>();

  const [showAddDimensionComponent, setShowAddDimensionComponent] =
    useState(false);
  const [selectedAddDimension, setSelectedAddDimension] = useState<
    string | null
  >(null);

  const selectedColumnConfig = useMemo<DimensionDefinition | undefined>(() => {
    return columns.find(
      (column) => column.columnHeaderValue === selectedColumnName,
    );
  }, [columns, selectedColumnName]);

  const language = useLanguage();

  const adminTable = useMemo(() => {
    const alignTop = () => 'align-top';
    return (
      <Table
        items={columns.map((level, index) => {
          return {
            ...level,
            index: index,
          };
        })}
        classNames={{
          tableContainer: 'overflow-x-scroll',
        }}
        columnDefinitions={[
          {
            id: 'id',
            header: () => <div>Id</div>,
            cellClassNames: alignTop,
            cell: ({ item }) => {
              let errMessage = '';
              const insight = insights.find(
                (insight) =>
                  insight.columnHeaderValue === item.columnHeaderValue,
              );
              if (insight) {
                if (insight.isInvalid) {
                  errMessage =
                    'This is no longer a value column. Please remove this.';
                }
                if (insight.didChangeLevels) {
                  errMessage =
                    errMessage +
                    'This column has changed levels. Levels have been updated.';
                }
              }

              return (
                <div>
                  <div className="font-bold">{item.columnHeaderValue}</div>
                  {errMessage.length > 0 && (
                    <div className="text-red-500">{errMessage}</div>
                  )}
                </div>
              );
            },
          },
          {
            id: 'name',
            header: () => <div>Name</div>,
            cellClassNames: alignTop,
            cell: ({ item }) => (
              <input
                className="form-input"
                type="text"
                key={' name'}
                value={item.displayName}
                aria-label={'name'}
                onChange={(event) => {
                  updateColumnEntry(item.index, {
                    displayName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'insightFormat',
            header: () => <div>Insight Format</div>,
            cellClassNames: alignTop,

            cell: ({ item }) => (
              <Spacing size={'md'} direction={'vertical'}>
                <SimpleInput
                  label={'Insight Format'}
                  value={getInsightFormatOrDefault(item.insightFormat)}
                  onChange={(newValue) => {
                    updateColumnEntry(item.index, {
                      insightFormat: newValue,
                    });
                  }}
                />

                <SimpleInput
                  label={'Insight w/ Reference Format'}
                  value={getInsightWithReferenceFormatOrDefault(
                    item.insightWithReferenceFormat,
                  )}
                  onChange={(newValue) => {
                    updateColumnEntry(item.index, {
                      insightWithReferenceFormat: newValue,
                    });
                  }}
                />

                <S2Checkbox
                  checked={getShowBeforeEmpsOrAppsOrDefault(
                    item.showBeforeEmpsOrApps,
                  )}
                  onChange={() => {
                    updateColumnEntry(item.index, {
                      showBeforeEmpsOrApps: !getShowBeforeEmpsOrAppsOrDefault(
                        item.showBeforeEmpsOrApps,
                      ),
                    });
                  }}
                >
                  Show Before Employees/Applicants
                </S2Checkbox>
              </Spacing>
            ),
          },
          {
            id: 'insightPreview',
            header: () => <div className={'w-[300px]'}>Insight Previews</div>,
            cellClassNames: alignTop,

            cell: ({ item }) => {
              const exampleInsights: Insight[] = [
                insight({
                  dimension: item.columnHeaderValue,
                  type: 'disparity',
                  treatmentLevel:
                    item.levels.find((l) => !l.isPrivileged)?.columnValue ??
                    'Black',
                  totalTestCount: {
                    passing: 2,
                    incomplete: 2,
                    failing: 1,
                  },
                  highlight: { type: 'higher', percentage: 76 },
                  referenceLevel:
                    item.levels.find((l) => l.isPrivileged)?.columnValue ??
                    'White',
                }),

                insight({
                  dimension: item.columnHeaderValue,
                  type: 'parity',
                  treatmentLevel:
                    item.levels.find((l) => !l.isPrivileged)?.columnValue ??
                    'Black',
                  totalTestCount: {
                    passing: 2,
                    incomplete: 2,
                    failing: 1,
                  },
                  highlight: { type: 'higher', percentage: 76 },
                  referenceLevel:
                    item.levels.find((l) => l.isPrivileged)?.columnValue ??
                    'White',
                }),

                insight({
                  dimension: item.columnHeaderValue,
                  type: 'optimization',
                  treatmentLevel:
                    item.levels.find((l) => !l.isPrivileged)?.columnValue ??
                    'Black',
                  totalTestCount: {
                    passing: 100,
                    incomplete: 0,
                    failing: 0,
                  },
                  highlight: { type: 'lower', percentage: 76 },
                  referenceLevel:
                    item.levels.find((l) => l.isPrivileged)?.columnValue ??
                    'White',
                }),

                insight({
                  dimension: item.columnHeaderValue,
                  type: 'optimization',
                  treatmentLevel:
                    item.levels.find((l) => !l.isPrivileged)?.columnValue ??
                    'Black',
                  totalTestCount: {
                    passing: 50,
                    incomplete: 0,
                    failing: 50,
                  },
                  highlight: { type: 'higher', percentage: 76 },
                  referenceLevel:
                    item.levels.find((l) => l.isPrivileged)?.columnValue ??
                    'White',
                }),

                insight({
                  dimension: item.columnHeaderValue,
                  type: 'optimization',
                  treatmentLevel:
                    item.levels.find((l) => !l.isPrivileged)?.columnValue ??
                    'Black',
                  totalTestCount: {
                    passing: 0,
                    incomplete: 0,
                    failing: 100,
                  },
                  highlight: { type: 'lower', percentage: 76 },
                  referenceLevel:
                    item.levels.find((l) => l.isPrivileged)?.columnValue ??
                    'White',
                }),
              ];

              return (
                <Spacing size={'sm'} direction={'vertical'}>
                  {exampleInsights.map((insight, i) => {
                    const insightDisplay = language.insightDisplay({
                      insightFormat: getInsightFormatOrDefault(
                        item.insightFormat,
                      ),
                      levelDisplay:
                        item.levels.find((l) => !l.isPrivileged)?.displayName ??
                        'Black',
                      showBeforeEmpsOrApps: getShowBeforeEmpsOrAppsOrDefault(
                        item.showBeforeEmpsOrApps,
                      ),
                      empsOrAppsDisplay: 'employees',
                    });

                    const insightWithReferenceDisplay =
                      language.insightWithReferenceDisplay({
                        showBeforeEmpsOrApps: getShowBeforeEmpsOrAppsOrDefault(
                          item.showBeforeEmpsOrApps,
                        ),
                        empsOrAppsDisplay: 'employees',
                        insightWithReferenceFormat:
                          getInsightWithReferenceFormatOrDefault(
                            item.insightWithReferenceFormat,
                          ),
                        levelDisplay:
                          item.levels.find((l) => !l.isPrivileged)
                            ?.displayName ?? 'Black',
                        referenceDisplay:
                          item.levels.find((l) => l.isPrivileged)
                            ?.displayName ?? 'White',
                      });

                    const lowerHigherDisplay = language.lowerHigherDisplay({
                      type: insight?.highlight?.type ?? '',
                    });

                    const focusAreaDisplay = 'Attrition';

                    return (
                      <Spacing key={i} size={'sm'} direction={'vertical'}>
                        <InsightImage
                          insight={insight}
                          calibrationFraming={DefaultCalibrationFraming}
                        />

                        <Paragraph textSize={'text-sm'}>
                          Title:{' '}
                          {language.insightTitleNew({
                            phrases: language,
                            insightDisplay,
                            insightWithReferenceDisplay,
                            focusAreaDisplay,
                            insight,
                            calibrationFraming: DefaultCalibrationFraming,
                          })}
                        </Paragraph>

                        <Paragraph textSize={'text-xs'}>
                          Summary:{' '}
                          {language.insightTextNew({
                            insight,
                            focusAreaDisplay,
                            insightDisplay,
                            phrases: language,
                            insightWithReferenceDisplay,
                            lowerHigherDisplay,
                            calibrationFraming: DefaultCalibrationFraming,
                          })}
                        </Paragraph>

                        <hr />
                      </Spacing>
                    );
                  })}
                </Spacing>
              );
            },
          },
          {
            id: 'rawColumn',
            header: () => <div>Corresponding Raw Column</div>,
            cellClassNames: alignTop,
            cell: ({ item }) => (
              <select
                value={item.correspondingRawColumnValue ?? 'N/A'}
                aria-label={'displayColor'}
                className="form-select w-full"
                onChange={(event) => {
                  if (event.target.value === 'N/A') {
                    updateColumnEntry(item.index, {
                      correspondingRawColumnValue: null,
                    });
                  } else {
                    updateColumnEntry(item.index, {
                      correspondingRawColumnValue: event.target.value,
                    });
                  }
                }}
              >
                <option key={'N/A'} value={'N/A'}>
                  {'N/A'}
                </option>
                {possibleRawCorrespondingSelections.map((option) => {
                  return (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  );
                })}
              </select>
            ),
          },
          {
            id: 'levels',
            header: () => <div>Display Icon</div>,
            cellClassNames: alignTop,
            cell: ({ item }) => (
              <div>
                <div>{item.levels.length} level(s)</div>
                <Button
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      setSelectedColumnName(item.columnHeaderValue);
                    },
                  }}
                  text="Edit Levels"
                />
              </div>
            ),
          },
          {
            id: 'delete',
            header: () => <div>Delete</div>,
            cellClassNames: alignTop,
            cell: ({ item }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    deleteColumnEntry(item.index);
                  },
                }}
                text={'Delete'}
              />
            ),
          },
        ]}
      />
    );
  }, [
    columns,
    deleteColumnEntry,
    insights,
    language,
    possibleRawCorrespondingSelections,
    updateColumnEntry,
  ]);

  return (
    <div>
      {selectedColumnConfig && (
        <DatabaseSchemaDimensionLevelsPage
          levels={selectedColumnConfig.levels}
          onSave={(levels) => {
            const configIndex = columns.findIndex(
              (value) => value.columnHeaderValue === selectedColumnName,
            );
            if (configIndex === -1) {
              setSelectedColumnName(undefined);
              return;
            }

            updateColumnEntry(configIndex, {
              levels: levels,
            });
            setSelectedColumnName(undefined);
          }}
          onBack={() => {
            setSelectedColumnName(undefined);
          }}
        />
      )}
      {!selectedColumnConfig && (
        <div className="py-1">
          <Button
            behavior={{
              type: 'onClick',
              onClick: () => {
                setShowAddDimensionComponent(true);
              },
            }}
            text="Add Dimension"
          />
          {showAddDimensionComponent && (
            <Spacing size="sm" direction="horizontal">
              <select
                className="form-select"
                value={selectedAddDimension ?? 'N/A'}
                onChange={(e) => {
                  setSelectedAddDimension(e.target.value);
                }}
              >
                <option key={'N/A'} value={'N/A'}>
                  {'N/A'}
                </option>
                {possibleDimensionSelections.map((selection) => (
                  <option key={selection.name} value={selection.name}>
                    {selection.name}
                  </option>
                ))}
              </select>
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    const selection = possibleDimensionSelections.find(
                      (selection) => selection.name === selectedAddDimension,
                    );
                    if (!selection) {
                      return;
                    }
                    addColumnEntry(selection);
                    setShowAddDimensionComponent(false);
                  },
                }}
                text="Add"
              />
            </Spacing>
          )}
          {adminTable}
        </div>
      )}
    </div>
  );
};

interface CurrentSelectionConfig {
  selectionType: 'control_variables' | 'metrics' | 'tools';
  index: number;
}

export const useDatabaseSchemaFocusAreaPage = ({
  focusAreaConfigs,
  updateColumnEntry,
  deleteColumnEntry,
  possibleMetricSelections,
  possibleControlVariableSelections,
  addFAEntry,
  focusAreaErrors,
  filterSets,
  dataIntelligenceDeepDiveIsEnabled,
  calibrationFraming,
  uniqueValuesByColumn,
  numericColumns,
  dateColumns,
}: {
  focusAreaConfigs: FocusAreaDefinition[];
  updateColumnEntry: (
    index: number,
    column: Partial<FocusAreaDefinition>,
  ) => void;
  deleteColumnEntry: (index: number) => void;
  possibleControlVariableSelections: string[];
  possibleMetricSelections: string[];
  addFAEntry: (possibleValue: FocusArea) => void;
  focusAreaErrors: DatabaseRevisionSchemaValidationFocusAreaError[];
  filterSets: FilterSetDefinitions;
  dataIntelligenceDeepDiveIsEnabled: boolean;
  calibrationFraming: CalibrationFraming;
  uniqueValuesByColumn: TransformInsights['uniqueValuesByColumn'];
  numericColumns: TransformInsights['numericColumns'];
  dateColumns: TransformInsights['dateColumns'];
}): ReactNode => {
  const [currentFocusAreaSelection, setCurrentFocusAreaSelection] = useState<
    CurrentSelectionConfig | undefined
  >();

  const selectedFocusAreaConfig = useMemo<
    FocusAreaDefinition | undefined
  >(() => {
    if (currentFocusAreaSelection === undefined) {
      return undefined;
    }
    return focusAreaConfigs.at(currentFocusAreaSelection.index);
  }, [currentFocusAreaSelection, focusAreaConfigs]);

  const onSaveControlVariables = useCallback(
    (controlVariables: ControlVariableDefinition[]) => {
      if (currentFocusAreaSelection === undefined) {
        setCurrentFocusAreaSelection(undefined);
        return;
      }
      updateColumnEntry(currentFocusAreaSelection.index, {
        controlVariables: [...controlVariables],
      });

      setCurrentFocusAreaSelection(undefined);
    },
    [currentFocusAreaSelection, updateColumnEntry],
  );

  const onSaveMetrics = useCallback(
    (metrics: MetricDefinition[]) => {
      if (currentFocusAreaSelection === undefined) {
        setCurrentFocusAreaSelection(undefined);
        return;
      }
      updateColumnEntry(currentFocusAreaSelection.index, {
        metrics: [...metrics],
      });

      setCurrentFocusAreaSelection(undefined);
    },
    [currentFocusAreaSelection, updateColumnEntry],
  );

  const onSaveTools = useCallback(
    (toolsDefinition: FocusAreaToolsDefinition) => {
      if (currentFocusAreaSelection === undefined) {
        setCurrentFocusAreaSelection(undefined);
        return;
      }
      updateColumnEntry(currentFocusAreaSelection.index, {
        toolsDefinition,
      });

      setCurrentFocusAreaSelection(undefined);
    },
    [currentFocusAreaSelection, updateColumnEntry],
  );

  const table = useMemo(() => {
    return (
      <Table
        items={focusAreaConfigs.map((value, index) => {
          return {
            ...value,
            index,
          };
        })}
        columnDefinitions={[
          {
            id: 'id',
            header: () => <div>Id</div>,
            cell: ({ item }) => <div>{item.focusArea}</div>,
          },
          {
            id: 'displayName',
            header: () => <div>Display Name</div>,
            cell: ({ item }) => (
              <input
                className="form-input"
                type="text"
                key={'name'}
                value={item.displayName ?? ''}
                aria-label={'name'}
                onChange={(event) => {
                  updateColumnEntry(item.index, {
                    displayName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'control_variables',
            header: () => <div>Control Variables</div>,
            cell: ({ item }) => {
              const error = focusAreaErrors.find(
                (insight) => insight.focusArea === item.focusArea,
              );
              const invalidControlVariables =
                error?.invalidControlVariables ?? [];
              let errMessage = '';
              if (invalidControlVariables.length > 0) {
                errMessage = `Invalid control variables: ${invalidControlVariables.join(
                  ', ',
                )}`;
              }
              return (
                <div>
                  <div>{`${item.controlVariables.length} total`}</div>
                  {errMessage.length > 0 && (
                    <div className="text-red-500">{errMessage}</div>
                  )}
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        setCurrentFocusAreaSelection({
                          index: item.index,
                          selectionType: 'control_variables',
                        });
                      },
                    }}
                    text={'Edit Control Variables'}
                  />
                </div>
              );
            },
          },
          {
            id: 'isHidden',
            header: () => <div>Is Hidden</div>,
            cell: ({ item }) => (
              <input
                className="form-checkbox"
                type="checkbox"
                key={'isHidden'}
                checked={Boolean(item.isHidden ?? false)}
                onChange={(event) => {
                  updateColumnEntry(item.index, {
                    isHidden: event.target.checked,
                  });
                }}
              />
            ),
          },
          {
            id: 'tools',
            header: () => <div>Tools</div>,
            cell: ({ item }) => {
              const validationErrors = getToolsDefinitionValidationErrors({
                toolsDefinition: inferFullToolsDefinitionWithDefaults(
                  item.toolsDefinition,
                ),
                filterSets,
                dataIntelligenceDeepDiveIsEnabled,
              });
              return (
                <div>
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        setCurrentFocusAreaSelection({
                          index: item.index,
                          selectionType: 'tools',
                        });
                      },
                    }}
                    text={'Edit Tools'}
                  />
                  {validationErrors.length > 0 && (
                    <FocusAreaToolsPreviewValidationErrors
                      validationErrors={validationErrors}
                    />
                  )}
                </div>
              );
            },
          },
          {
            id: 'metrics',
            header: () => <div>Metrics</div>,
            cell: ({ item }) => {
              const error = focusAreaErrors.find(
                (insight) => insight.focusArea === item.focusArea,
              );
              const invalidMetrics = error?.invalidMetrics ?? [];
              let errMessage = '';
              if (invalidMetrics.length > 0) {
                errMessage = `Invalid metrics: ${invalidMetrics.join(', ')}`;
              }
              return (
                <div>
                  <div>{`${item.metrics.length} total`}</div>
                  {errMessage.length > 0 && (
                    <div className="text-red-500">{errMessage}</div>
                  )}
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        setCurrentFocusAreaSelection({
                          index: item.index,
                          selectionType: 'metrics',
                        });
                      },
                    }}
                    text={'Edit Metrics'}
                  />
                </div>
              );
            },
          },
          {
            id: 'delete',
            header: () => <div>Delete</div>,
            cell: ({ item }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    deleteColumnEntry(item.index);
                  },
                }}
                text={'Delete'}
              />
            ),
          },
        ]}
      />
    );
  }, [
    dataIntelligenceDeepDiveIsEnabled,
    deleteColumnEntry,
    filterSets,
    focusAreaConfigs,
    focusAreaErrors,
    updateColumnEntry,
  ]);

  return (
    <div>
      {selectedFocusAreaConfig &&
        currentFocusAreaSelection?.selectionType === 'control_variables' && (
          <DatabaseSchemaFocusAreaControlVariablesPage
            focusAreaName={selectedFocusAreaConfig.focusArea}
            controlVariables={selectedFocusAreaConfig.controlVariables}
            onSave={onSaveControlVariables}
            onBack={() => {
              setCurrentFocusAreaSelection(undefined);
            }}
            possibleValues={possibleControlVariableSelections}
            uniqueValuesByColumn={uniqueValuesByColumn}
            numericColumns={numericColumns}
            dateColumns={dateColumns}
          />
        )}
      {selectedFocusAreaConfig &&
        currentFocusAreaSelection?.selectionType === 'metrics' && (
          <DatabaseSchemaFocusAreaMetricsPage
            focusAreaDefinition={selectedFocusAreaConfig}
            metrics={selectedFocusAreaConfig.metrics}
            onSave={onSaveMetrics}
            onBack={() => {
              setCurrentFocusAreaSelection(undefined);
            }}
            possibleValues={possibleMetricSelections}
            calibrationFraming={calibrationFraming}
          />
        )}
      {selectedFocusAreaConfig &&
        currentFocusAreaSelection?.selectionType === 'tools' && (
          <DatabaseSchemaFocusAreaToolsPage
            focusArea={selectedFocusAreaConfig.focusArea}
            toolsDefinition={inferFullToolsDefinitionWithDefaults(
              selectedFocusAreaConfig.toolsDefinition,
            )}
            filterSets={filterSets}
            dataIntelligenceDeepDiveIsEnabled={
              dataIntelligenceDeepDiveIsEnabled
            }
            onSave={onSaveTools}
            onBack={() => {
              setCurrentFocusAreaSelection(undefined);
            }}
          />
        )}
      {!selectedFocusAreaConfig && (
        <div>
          <AddSchemaSelectionComponent
            possibleValues={FocusAreas.map((value) => {
              return {
                optionKey: value,
                optionValue: value,
                optionLabel: value,
              };
            })}
            addEntry={(entry) => {
              addFAEntry(entry);
            }}
            entryType="Focus Area"
          />
          {table}
        </div>
      )}
    </div>
  );
};

export const useDatabaseSchemaFilterPage = ({
  filterSets,
  onUpdateFilterSets,
  uniqueValuesByColumn,
  dateColumns,
  numericColumns,
  filterErrors,
}: {
  filterSets: FilterSetDefinitions;
  onUpdateFilterSets: (filterSets: FilterSetDefinitions) => void;
  uniqueValuesByColumn: TransformInsights['uniqueValuesByColumn'];
  numericColumns: TransformInsights['numericColumns'];
  dateColumns: TransformInsights['dateColumns'];
  filterErrors: DatabaseRevisionSchemaValidationFilterError[];
}): ReactNode => {
  const language = useLanguage();

  const [stagingFilterSetDefinition, setStagingFilterSetDefinition] =
    useState<FilterSetDefinition | null>(null);

  const addFilterSet = useCallback(() => {
    onUpdateFilterSets([
      ...filterSets,
      {
        filterSetName: `new_filter_set_${filterSets.length}`,
        filterDefinitions: [],
      },
    ]);
  }, [filterSets, onUpdateFilterSets]);

  // Represents which filter set is currently being edited (indexed from allFilterSets)
  const [activeFilterSetIndex, setActiveFilterSetIndex] = useState<number>(-1);

  const activeFilterSet = useMemo(() => {
    if (activeFilterSetIndex < 0 || activeFilterSetIndex >= filterSets.length) {
      return null;
    }

    return filterSets[activeFilterSetIndex] ?? null;
  }, [activeFilterSetIndex, filterSets]);

  const navigateToFilterSet = useCallback(
    (index: number) => {
      if (index < 0 || index >= filterSets.length) {
        return;
      }

      const fs = filterSets[index];

      if (fs) {
        setActiveFilterSetIndex(index);
        setStagingFilterSetDefinition(fs);
      }
    },
    [filterSets],
  );

  const showFilterSetList = useMemo(() => !activeFilterSet, [activeFilterSet]);
  const showFilterList = useMemo(() => !!activeFilterSet, [activeFilterSet]);

  const possibleFilterColumns = useMemo(
    () =>
      getPossibleFilterColumns({
        numericColumns,
        dateColumns,
        uniqueValuesByColumn,
      }),
    [dateColumns, numericColumns, uniqueValuesByColumn],
  );

  const stagingNameInvalid = useMemo(() => {
    const stagingNameIsUnique =
      filterSets.filter(
        (f, i) =>
          i !== activeFilterSetIndex &&
          f.filterSetName === stagingFilterSetDefinition?.filterSetName,
      ).length === 0;

    const stagingNameIsBadDefaultName =
      activeFilterSet !== null &&
      stagingFilterSetDefinition !== null &&
      activeFilterSet.filterSetName !== FILTER_SET_DEFAULT_NAME &&
      stagingFilterSetDefinition.filterSetName === FILTER_SET_DEFAULT_NAME;

    const empty =
      stagingFilterSetDefinition !== null &&
      stagingFilterSetDefinition.filterSetName.trim() === '';

    return !stagingNameIsUnique || stagingNameIsBadDefaultName || empty;
  }, [
    activeFilterSet,
    activeFilterSetIndex,
    filterSets,
    stagingFilterSetDefinition,
  ]);

  return (
    <div>
      {showFilterSetList && (
        <>
          <S2Typography
            variant={'headline-3'}
            translatedContent={language.filterSetsHeading()}
          />
          <Spacing direction={'vertical'} size={'md'}>
            <Button
              behavior={{
                type: 'onClick',
                onClick: addFilterSet,
              }}
              text={'Add Filter Set'}
            />
            <Table
              items={filterSets}
              columnDefinitions={[
                {
                  id: 'name',
                  header: () => <div>Name</div>,
                  cell: ({ item }) => {
                    const invalidNameError = filterErrors.find(
                      (insight) =>
                        insight.filterSetName === item.filterSetName &&
                        insight.details.reason === 'invalid-filter-set-name',
                    );
                    return (
                      <>
                        {invalidNameError && (
                          <div className="text-red-500">
                            {invalidNameError.details.reason}
                          </div>
                        )}
                        <div>{item.filterSetName}</div>
                      </>
                    );
                  },
                },
                {
                  id: 'edit',
                  header: () => <div>Edit</div>,
                  cell: ({ rowIndex }) => (
                    <Button
                      behavior={{
                        type: 'onClick',
                        onClick: () => {
                          navigateToFilterSet(rowIndex);
                        },
                      }}
                      text={'Edit'}
                    />
                  ),
                },
                {
                  id: 'delete',
                  header: () => <div>Delete</div>,
                  cell: ({ item, rowIndex }) =>
                    item.filterSetName === FILTER_SET_DEFAULT_NAME ? (
                      <></>
                    ) : (
                      <Button
                        behavior={{
                          type: 'onClick',
                          onClick: () => {
                            onUpdateFilterSets(
                              filterSets.filter((_, i) => i !== rowIndex),
                            );
                          },
                        }}
                        text={'Delete'}
                      />
                    ),
                },
              ]}
            />
          </Spacing>
        </>
      )}

      {showFilterList &&
        activeFilterSet &&
        stagingFilterSetDefinition !== null && (
          <Spacing direction={'vertical'} size={'md'}>
            <Spacing direction={'horizontal'} size={'md'}>
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    setActiveFilterSetIndex(-1);
                    setStagingFilterSetDefinition(null);
                  },
                }}
                text={'Cancel (Back to filter sets)'}
              />

              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    if (
                      stagingNameInvalid ||
                      activeFilterSetIndex < 0 ||
                      activeFilterSetIndex >= filterSets.length
                    ) {
                      return;
                    }

                    const newFilterSets = filterSets.map((f, i) =>
                      i === activeFilterSetIndex
                        ? stagingFilterSetDefinition
                        : f,
                    );
                    onUpdateFilterSets(newFilterSets);
                    setActiveFilterSetIndex(-1);
                  },
                }}
                disabled={stagingNameInvalid}
                text={'Save Filter Set Changes'}
              />
            </Spacing>
            {stagingNameInvalid && (
              <div className={'text-red-500'}>
                This name is not valid, please choose a different name.
              </div>
            )}
            <Spacing direction={'horizontal'} size={'md'}>
              <SimpleInput
                label={'Filter Set Name'}
                value={stagingFilterSetDefinition.filterSetName}
                disabled={
                  activeFilterSet.filterSetName === FILTER_SET_DEFAULT_NAME
                }
                onChange={(newValue) => {
                  setStagingFilterSetDefinition({
                    ...stagingFilterSetDefinition,
                    filterSetName: newValue,
                  });
                }}
              />
            </Spacing>

            <AddSchemaSelectionComponent
              label={'filter'}
              possibleValues={possibleFilterColumns.map((value) => {
                const allowances = checkIfColumnIsAllowedToBeFilter({
                  dateColumns,
                  uniqueValuesByColumn,
                  numericColumns,
                  column: value,
                });

                const uniqueValuesCount =
                  uniqueValuesByColumn.find(
                    (uniqueValues) => uniqueValues.columnName === value,
                  )?.uniqueValues.length ?? 0;

                let fullLabel = value;
                if (uniqueValuesCount > 0) {
                  fullLabel += ` (${uniqueValuesCount} uniques)`;
                }

                if (allowances.allowedDisplayTypes.includes('range_date')) {
                  fullLabel += ' (date range)';
                }

                if (allowances.allowedDisplayTypes.includes('range_scalar')) {
                  fullLabel += ' (scalar range)';
                }

                return {
                  optionKey: value,
                  optionValue: value,
                  optionLabel: fullLabel,
                };
              })}
              addEntry={(entry) => {
                setStagingFilterSetDefinition({
                  ...stagingFilterSetDefinition,
                  filterDefinitions: [
                    ...stagingFilterSetDefinition.filterDefinitions,
                    {
                      columnHeaderValue: entry,
                      displayName: entry,
                      usageType: null,
                      dependsOn: [],
                    },
                  ],
                });
              }}
              entryType={'Filter'}
            />
            <Table
              items={stagingFilterSetDefinition.filterDefinitions}
              columnDefinitions={[
                {
                  id: 'id',
                  header: () => <div>Id</div>,
                  cell: ({ item }) => {
                    let errMessage = '';
                    const insight = filterErrors.find(
                      (insight) =>
                        'columnHeaderValue' in insight.details &&
                        insight.details.columnHeaderValue ===
                          item.columnHeaderValue,
                    );
                    if (insight) {
                      errMessage = insight.details.reason;
                    }
                    return (
                      <div>
                        <div>{item.columnHeaderValue}</div>
                        {errMessage.length > 0 && (
                          <div className="text-red-500">{errMessage}</div>
                        )}
                      </div>
                    );
                  },
                },
                {
                  id: 'display_name',
                  header: () => <div>Display Name</div>,
                  cell: ({ item, rowIndex }) => (
                    <input
                      className="form-input"
                      type="text"
                      value={item.displayName}
                      onChange={(e) => {
                        const newDisplayName = e.target.value;
                        setStagingFilterSetDefinition({
                          ...stagingFilterSetDefinition,
                          filterDefinitions:
                            stagingFilterSetDefinition.filterDefinitions.map(
                              (f, i) =>
                                i === rowIndex
                                  ? {
                                      ...f,
                                      displayName: newDisplayName,
                                    }
                                  : f,
                            ),
                        });
                      }}
                    />
                  ),
                },
                {
                  id: 'usageType',
                  header: () => <div>Usage Type</div>,
                  cell: ({ item, rowIndex }) => (
                    <SchemaSelectionComponent
                      possibleValues={FilterDefinitionUsageTypes.map(
                        (value) => {
                          return {
                            optionKey: value,
                            optionValue: value,
                            optionLabel: value,
                          };
                        },
                      )}
                      selectedValueKey={item.usageType ?? null}
                      setSelectedValue={(key) => {
                        if (key) {
                          setStagingFilterSetDefinition({
                            ...stagingFilterSetDefinition,
                            filterDefinitions:
                              stagingFilterSetDefinition.filterDefinitions.map(
                                (f, i) =>
                                  i === rowIndex
                                    ? {
                                        ...f,
                                        usageType:
                                          FilterDefinitionUsageType.parse(key),
                                      }
                                    : f,
                              ),
                          });
                        }
                      }}
                    />
                  ),
                },
                {
                  id: 'displayType',
                  header: () => <div>Display Type</div>,
                  cell: ({ item, rowIndex }) => {
                    const allowances = checkIfColumnIsAllowedToBeFilter({
                      dateColumns,
                      uniqueValuesByColumn,
                      numericColumns,
                      column: item.columnHeaderValue,
                    });

                    const numericColumn =
                      numericColumns?.[item.columnHeaderValue] ?? null;

                    return (
                      <Spacing direction={'vertical'} size={'md'}>
                        <SchemaSelectionComponent
                          possibleValues={allowances.allowedDisplayTypes.map(
                            (displayType) => {
                              return {
                                optionKey: displayType,
                                optionValue: displayType,
                                optionLabel: displayType,
                              };
                            },
                          )}
                          selectedValueKey={
                            item.displayType ??
                            FILTER_DEFINITION_DEFAULT_DISPLAY_TYPE
                          }
                          setSelectedValue={(key) => {
                            if (key) {
                              const newDisplayType =
                                FilterDefinitionDisplayType.parse(key);

                              setStagingFilterSetDefinition({
                                ...stagingFilterSetDefinition,
                                filterDefinitions:
                                  stagingFilterSetDefinition.filterDefinitions.map(
                                    (f, i) =>
                                      i === rowIndex
                                        ? {
                                            ...f,
                                            displayType: newDisplayType,
                                            displayTypePrecision:
                                              newDisplayType !== 'range_scalar'
                                                ? undefined
                                                : f.displayTypePrecision,
                                          }
                                        : f,
                                  ),
                              });
                            }
                          }}
                        />

                        {item.displayType === 'range_scalar' &&
                          numericColumn &&
                          !numericColumn.isInteger && (
                            <Spacing size={''} direction={'vertical'}>
                              <S2Typography
                                variant={'body-6'}
                                translatedContent={language.precision()}
                              />
                              <S2NumberField
                                value={item.displayTypePrecision ?? 0}
                                min={0}
                                max={8}
                                format={{ maximumFractionDigits: 0 }}
                                onValueCommitted={(value) => {
                                  setStagingFilterSetDefinition({
                                    ...stagingFilterSetDefinition,
                                    filterDefinitions:
                                      stagingFilterSetDefinition.filterDefinitions.map(
                                        (f, i) =>
                                          i === rowIndex
                                            ? {
                                                ...f,
                                                displayTypePrecision:
                                                  value ?? undefined,
                                              }
                                            : f,
                                      ),
                                  });
                                }}
                              />
                            </Spacing>
                          )}
                      </Spacing>
                    );
                  },
                },
                {
                  id: 'attributes',
                  header: () => <div>Attributes</div>,
                  cell: ({ item }) => {
                    return (
                      <AttributesColumn
                        columnHeaderValue={item.columnHeaderValue}
                        uniqueValuesByColumn={uniqueValuesByColumn}
                        numericColumns={numericColumns}
                        dateColumns={dateColumns}
                      />
                    );
                  },
                },
                {
                  id: 'depends_items',
                  header: () => <div>Depends On</div>,
                  cell: ({ item }) => {
                    const currentGraph = buildDependencyGraph(
                      stagingFilterSetDefinition.filterDefinitions,
                    );
                    const wouldCreateCircularDependency = ({
                      filterColumnHeaderValue,
                      newDependencyColumnHeaderValue,
                    }: {
                      filterColumnHeaderValue: string;
                      newDependencyColumnHeaderValue: string;
                    }): boolean => {
                      const newPotentialGraph = buildDependencyGraph(
                        stagingFilterSetDefinition.filterDefinitions.map(
                          (c) => {
                            if (
                              c.columnHeaderValue !== filterColumnHeaderValue
                            ) {
                              return c;
                            }
                            return {
                              ...c,
                              dependsOn: [
                                ...(c.dependsOn ?? []),
                                newDependencyColumnHeaderValue,
                              ],
                            };
                          },
                        ),
                      );
                      const newPotentialFullGraph =
                        buildFilterFullDependencyGraphOrNullOnCircularReference(
                          newPotentialGraph,
                        );
                      return newPotentialFullGraph === null;
                    };
                    const doesNewDependencyAlreadyDependOnUs = ({
                      filterColumnHeaderValue,
                      newDependencyColumnHeaderValue,
                    }: {
                      filterColumnHeaderValue: string;
                      newDependencyColumnHeaderValue: string;
                    }): boolean => {
                      const currentFullGraph =
                        buildFilterFullDependencyGraphOrNullOnCircularReference(
                          currentGraph,
                        );
                      if (currentFullGraph === null) {
                        return true;
                      }
                      const col =
                        currentFullGraph[newDependencyColumnHeaderValue] ?? [];
                      return col.includes(filterColumnHeaderValue);
                    };
                    return (
                      <SelectBoxWithSearch
                        type={'multi'}
                        list={stagingFilterSetDefinition.filterDefinitions
                          .filter(
                            (c) =>
                              c.columnHeaderValue !== item.columnHeaderValue &&
                              !wouldCreateCircularDependency({
                                filterColumnHeaderValue: item.columnHeaderValue,
                                newDependencyColumnHeaderValue:
                                  c.columnHeaderValue,
                              }) &&
                              !doesNewDependencyAlreadyDependOnUs({
                                filterColumnHeaderValue: item.columnHeaderValue,
                                newDependencyColumnHeaderValue:
                                  c.columnHeaderValue,
                              }),
                          )
                          .map((c) => {
                            return {
                              optionValue: c.columnHeaderValue,
                              optionLabel: c.columnHeaderValue,
                            };
                          })}
                        label={'Depends On'}
                        setSelected={(newOptions) => {
                          if (typeof newOptions === 'function') {
                            return;
                          }
                          setStagingFilterSetDefinition({
                            ...stagingFilterSetDefinition,
                            filterDefinitions:
                              stagingFilterSetDefinition.filterDefinitions.map(
                                (f) =>
                                  f.columnHeaderValue === item.columnHeaderValue
                                    ? {
                                        ...f,
                                        dependsOn: newOptions,
                                      }
                                    : f,
                              ),
                          });
                        }}
                        selected={item.dependsOn ?? []}
                      />
                    );
                  },
                },
                {
                  id: 'preview',
                  header: () => <div>Preview</div>,
                  cell: ({ item, rowIndex }) => {
                    const uniqueValues =
                      uniqueValuesByColumn.find(
                        (uniqueValues) =>
                          uniqueValues.columnName === item.columnHeaderValue,
                      )?.uniqueValues ?? [];

                    return (
                      <FilterSelectBox
                        key={rowIndex}
                        type={'single'}
                        filterInformation={{
                          columnHeaderValue: item.columnHeaderValue,
                          displayName: item.displayName,
                          values: uniqueValues.sort(),
                          selectedValues: [],
                        }}
                        onSelect={() => {
                          return null;
                        }}
                        isProcessing={false}
                      />
                    );
                  },
                },
                {
                  id: 'delete',
                  header: () => <div>Delete</div>,
                  cell: ({ rowIndex }) => (
                    <Button
                      behavior={{
                        type: 'onClick',
                        onClick: () => {
                          setStagingFilterSetDefinition({
                            ...stagingFilterSetDefinition,
                            filterDefinitions:
                              stagingFilterSetDefinition.filterDefinitions.filter(
                                (_, i) => i !== rowIndex,
                              ),
                          });
                        },
                      }}
                      text={'Delete'}
                    />
                  ),
                },
              ]}
            />
          </Spacing>
        )}
    </div>
  );
};

const DatabaseSchemaOverviewPageConfigCustomPage = ({
  config,
  setConfig,
  filterSets,
  focusAreaDefinitions,
  uniqueValuesByColumn,
}: {
  config: OverviewPageConfiguration;
  setConfig: (config: OverviewPageCustomDashboardConfiguration) => void;
  filterSets: FilterSetDefinitions;
  focusAreaDefinitions: FocusAreaDefinition[];
  uniqueValuesByColumn: TransformUniqueValuesByColumnItem[];
}) => {
  if (config.type !== 'custom') {
    throw new Error('Invalid config type');
  }

  const defaultFilterSet = useMemo(() => {
    return resolveFilterSet({
      filterSets,
      filterSetName: FILTER_SET_DEFAULT_NAME,
    });
  }, [filterSets]);

  const primaryFiltersList = useMemo(() => {
    return (
      defaultFilterSet?.filterDefinitions.map((filter) => {
        return {
          optionLabel: filter.displayName,
          optionValue: filter.columnHeaderValue,
        };
      }) ?? []
    );
  }, [defaultFilterSet?.filterDefinitions]);

  const primaryFilterOptionsList = useMemo(() => {
    const foundFilter =
      defaultFilterSet?.filterDefinitions.find(
        (filter) =>
          filter.columnHeaderValue === config.configuration.primaryFilterId,
      ) ?? null;

    if (!foundFilter) {
      return [];
    }

    const uniqueValues =
      uniqueValuesByColumn.find(
        (item) => item.columnName === foundFilter.columnHeaderValue,
      )?.uniqueValues ?? [];

    return uniqueValues.map((value) => {
      return {
        optionLabel: value,
        optionValue: value,
      };
    });
  }, [
    config.configuration.primaryFilterId,
    defaultFilterSet?.filterDefinitions,
    uniqueValuesByColumn,
  ]);

  const secondaryFiltersList = useMemo(() => {
    return (
      defaultFilterSet?.filterDefinitions.map((filter) => {
        return {
          optionLabel: filter.displayName,
          optionValue: filter.columnHeaderValue,
        };
      }) ?? []
    );
  }, [defaultFilterSet?.filterDefinitions]);

  const focusAreasList = useMemo(() => {
    return focusAreaDefinitions.map((focusArea) => {
      return {
        optionLabel: focusArea.focusArea,
        optionValue: focusArea.focusArea,
      };
    });
  }, [focusAreaDefinitions]);

  return (
    <div>
      <SelectBoxWithSearch
        type={'single'}
        list={focusAreasList}
        label={'Focus Area'}
        selected={config.configuration.focusAreaId}
        setSelected={(value) => {
          if (typeof value === 'string') {
            setConfig({
              ...config,
              configuration: {
                ...config.configuration,
                focusAreaId: value,
              },
            });
          }
        }}
      />

      <SelectBoxWithSearch
        type={'single'}
        list={primaryFiltersList}
        label={'Primary Filter'}
        setSelected={(value) => {
          if (typeof value === 'string') {
            setConfig({
              ...config,
              configuration: {
                ...config.configuration,
                primaryFilterId: value,
              },
            });
          }
        }}
        selected={config.configuration.primaryFilterId}
      />

      <SelectBoxWithSearch
        type={'single'}
        list={primaryFilterOptionsList}
        label={'Primary Filter Option'}
        setSelected={(value) => {
          if (typeof value === 'string') {
            setConfig({
              ...config,
              configuration: {
                ...config.configuration,
                primaryFilterSelection: value,
              },
            });
          }
        }}
        selected={config.configuration.primaryFilterSelection}
      />

      <SelectBoxWithSearch
        type={'single'}
        list={secondaryFiltersList}
        label={'Secondary Filter'}
        setSelected={(value) => {
          if (typeof value === 'string') {
            setConfig({
              ...config,
              configuration: {
                ...config.configuration,
                secondaryFilterId: value,
              },
            });
          }
        }}
        selected={config.configuration.secondaryFilterId}
      />
    </div>
  );
};

export const useDatabaseSchemaOverviewPageConfigPage = ({
  currentConfig,
  setCurrentConfig,
  filterSets,
  focusAreaDefinitions,
  uniqueValuesByColumn,
}: {
  currentConfig: OverviewPageConfiguration;
  setCurrentConfig: (config: OverviewPageConfiguration) => void;
  filterSets: FilterSetDefinitions;
  focusAreaDefinitions: FocusAreaDefinition[];
  uniqueValuesByColumn: TransformUniqueValuesByColumnItem[];
}) => {
  const typesToList = useMemo(() => {
    return OverviewPageConfigurationTypes.map((type) => {
      return {
        optionLabel: type,
        optionValue: type,
      };
    });
  }, []);

  const setDefaultConfiguration = useCallback(
    (config: OverviewPageDefaultConfiguration) => {
      setCurrentConfig(config);
    },
    [setCurrentConfig],
  );

  const setNoIntelligenceConfiguration = useCallback(
    (config: OverviewPageNoIntelligenceConfiguration) => {
      setCurrentConfig(config);
    },
    [setCurrentConfig],
  );

  const setCustomConfiguration = useCallback(
    (config: OverviewPageCustomDashboardConfiguration) => {
      setCurrentConfig(config);
    },
    [setCurrentConfig],
  );

  const setConfiguration = useCallback(
    (configType: OverviewPageConfigurationType) => {
      if (configType === 'default') {
        setDefaultConfiguration({
          type: 'default',
        });
      } else if (configType === 'no-intelligence') {
        setNoIntelligenceConfiguration({
          type: 'no-intelligence',
        });
      } else if (configType === 'custom') {
        setCustomConfiguration({
          type: 'custom',
          configuration: {
            focusAreaId: 'Hiring',
            primaryFilterId: '',
            secondaryFilterId: '',
            primaryFilterSelection: '',
            modelVersion: 'v1',
          },
        });
      } else {
        throw guardExhaustive(configType);
      }
    },
    [
      setCustomConfiguration,
      setDefaultConfiguration,
      setNoIntelligenceConfiguration,
    ],
  );

  const currentUiDetailsPage = useMemo(() => {
    if (
      currentConfig.type === 'default' ||
      currentConfig.type === 'no-intelligence'
    ) {
      // These do not need additional configuration for now.
      return <div></div>;
    } else if (currentConfig.type === 'custom') {
      return (
        <DatabaseSchemaOverviewPageConfigCustomPage
          config={currentConfig}
          setConfig={setCurrentConfig}
          filterSets={filterSets}
          focusAreaDefinitions={focusAreaDefinitions}
          uniqueValuesByColumn={uniqueValuesByColumn}
        />
      );
    } else {
      throw guardExhaustive(currentConfig);
    }
  }, [
    currentConfig,
    filterSets,
    focusAreaDefinitions,
    setCurrentConfig,
    uniqueValuesByColumn,
  ]);

  return (
    <div>
      <SelectBoxWithSearch
        type={'single'}
        list={typesToList}
        label={'Type'}
        setSelected={setConfiguration}
        selected={currentConfig.type}
      />
      {currentUiDetailsPage}
    </div>
  );
};

export const useDatabaseSchemaCopilotPage = ({
  copilotDefinitions,
  updateColumnEntry,
  deleteColumnEntry,
  addCopilotEntry,
  copilotErrors,
  organizationId,
  listDataSetVersionsFullPattern,
  copilotAutoMLConfiguration,
  setCopilotAutoMLConfiguration,
}: {
  copilotDefinitions: FullCopilotDefinition[];
  updateColumnEntry: (
    index: number,
    column: Partial<FullCopilotDefinition>,
  ) => void;
  deleteColumnEntry: (index: number) => void;
  addCopilotEntry: (possibleValue: CopilotType) => void;
  copilotErrors: DatabaseRevisionSchemaValidationCopilotError[];
  organizationId: string;
  listDataSetVersionsFullPattern: ReadPatternHook<DataSetVersionsFull>;
  copilotAutoMLConfiguration?: CopilotAutoMLConfiguration;
  setCopilotAutoMLConfiguration: Setter<CopilotAutoMLConfiguration>;
}): ReactNode => {
  const language = useLanguage();
  const selectExternalPayBenchmarkingForHiringCopilot = useCallback(
    (index: number, newRef: DataSetReference | null) => {
      const existingDef = copilotDefinitions.find(
        (def) => def.copilotType === 'hiring',
      );

      if (!existingDef || existingDef.copilotType !== 'hiring') {
        return;
      }

      const newCopilotDef: FullHiringCopilotDefinition = {
        ...existingDef,
        externalPayBenchmarkingReference: newRef ?? undefined,
      };

      updateColumnEntry(index, newCopilotDef);
    },
    [copilotDefinitions, updateColumnEntry],
  );

  const selectExternalPayBenchmarkingForPayBenchmarkingCopilot = useCallback(
    (index: number, newRef: DataSetReference | null) => {
      const existingDef = copilotDefinitions.find(
        (def) => def.copilotType === 'pay-benchmarking',
      );

      if (!existingDef || existingDef.copilotType !== 'pay-benchmarking') {
        return;
      }

      const newCopilotDef: FullPayBenchmarkingCopilotDefinition = {
        ...existingDef,
        externalPayBenchmarkingReference: newRef ?? undefined,
      };

      updateColumnEntry(index, newCopilotDef);
    },
    [copilotDefinitions, updateColumnEntry],
  );

  const selectInternalPayBenchmarkingForPayCorrectionCopilot = useCallback(
    (index: number, newRef: DataSetReference | null) => {
      const existingDef = copilotDefinitions.find(
        (def) => def.copilotType === 'pay-correction',
      );

      if (!existingDef || existingDef.copilotType !== 'pay-correction') {
        return;
      }

      const newCopilotDef: FullPayCorrectionCopilotDefinition = {
        ...existingDef,
        internalPayBenchmarkingReference: newRef ?? undefined,
      };

      updateColumnEntry(index, newCopilotDef);
    },
    [copilotDefinitions, updateColumnEntry],
  );

  const copilotAutoMLConfigurationErrors = useMemo(() => {
    return copilotAutoMLConfiguration
      ? validateCopilotAutoMLConfiguration(copilotAutoMLConfiguration)
      : [];
  }, [copilotAutoMLConfiguration]);

  return useMemo(() => {
    return (
      <div>
        <Box as="section">
          <Spacing direction="vertical" size="sm">
            <S2Typography
              variant={'headline-5'}
              translatedContent={language.copilotAutoMLConfigurationSectionLabel()}
            />
            <SelectBoxWithSearch
              type="single"
              selected={copilotAutoMLConfiguration?.preset ?? 'no_automl'}
              setSelected={(p) => {
                if (p === copilotAutoMLConfiguration?.preset) {
                  return;
                }

                if (p === 'custom') {
                  setCopilotAutoMLConfiguration(
                    CopilotAutoMLDefaultCustomConfiguration,
                  );
                } else {
                  setCopilotAutoMLConfiguration({
                    preset: p,
                  });
                }
              }}
              list={CopilotAutoMLConfigurationPreset.options.map((p) => {
                return {
                  optionValue: p,
                  optionLabel:
                    language.copilotAutoMLConfigurationPresetOptionLabel({
                      copilotAutoMLConfigurationPreset: p,
                    }),
                };
              })}
              label={language.copilotAutoMLConfigurationPresetSelectLabel()}
            />
            {copilotAutoMLConfiguration?.preset === 'custom' && (
              <Spacing direction="vertical" size="md">
                <Spacing direction="horizontal" size="sm">
                  <SelectBoxWithSearch
                    type="single"
                    selected={copilotAutoMLConfiguration.taskType}
                    setSelected={(t) => {
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        taskType: t,
                      });
                    }}
                    list={CopilotAutoMLConfigurationTaskType.options.map(
                      (t) => {
                        return {
                          optionValue: t,
                          optionLabel: t,
                        };
                      },
                    )}
                    label={'Task Type'}
                  />
                  <SelectBoxWithSearch
                    type="single"
                    selected={copilotAutoMLConfiguration.modelApproach}
                    setSelected={(a) => {
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        modelApproach: a,
                      });
                    }}
                    list={CopilotAutoMLConfigurationApproachType.options.map(
                      (a) => {
                        return {
                          optionValue: a,
                          optionLabel: a,
                        };
                      },
                    )}
                    label={'Model Approach'}
                  />
                  <S2Checkbox
                    checked={copilotAutoMLConfiguration.targetEncoding}
                    onChange={() =>
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        targetEncoding:
                          !copilotAutoMLConfiguration.targetEncoding,
                      })
                    }
                  >
                    Target Encoding
                  </S2Checkbox>
                </Spacing>
                <Spacing direction="horizontal" size="sm">
                  <label>
                    NA Column Filter
                    <NumberInput
                      value={
                        copilotAutoMLConfiguration.featureSelection
                          .naColumnFilter
                      }
                      onUpdate={(newValue) => {
                        setCopilotAutoMLConfiguration({
                          ...copilotAutoMLConfiguration,
                          featureSelection: {
                            ...copilotAutoMLConfiguration.featureSelection,
                            naColumnFilter:
                              newValue ??
                              CopilotAutoMLDefaultCustomConfigurationNaColumnFilter,
                          },
                        });
                      }}
                      placeholder=""
                      showErrorHint={copilotAutoMLConfigurationErrors.some(
                        (e) => e.reason === 'na-column-filter-invalid',
                      )}
                    />
                  </label>
                  <label>
                    Selected Top Percentile
                    <NumberInput
                      value={
                        copilotAutoMLConfiguration.featureSelection
                          .selectedTopPercentile
                      }
                      onUpdate={(newValue) => {
                        setCopilotAutoMLConfiguration({
                          ...copilotAutoMLConfiguration,
                          featureSelection: {
                            ...copilotAutoMLConfiguration.featureSelection,
                            selectedTopPercentile:
                              newValue ??
                              CopilotAutoMLDefaultCustomConfigurationSelectedTopPercentile,
                          },
                        });
                      }}
                      placeholder=""
                      showErrorHint={copilotAutoMLConfigurationErrors.some(
                        (e) => e.reason === 'selected-top-percentile-invalid',
                      )}
                    />
                  </label>
                  <S2Checkbox
                    checked={
                      copilotAutoMLConfiguration.featureSelection
                        .removeNaForSelection
                    }
                    onChange={() =>
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        featureSelection: {
                          ...copilotAutoMLConfiguration.featureSelection,
                          removeNaForSelection:
                            !copilotAutoMLConfiguration.featureSelection
                              .removeNaForSelection,
                        },
                      })
                    }
                  >
                    Remove NA for Selection
                  </S2Checkbox>
                  <S2Checkbox
                    checked={
                      copilotAutoMLConfiguration.featureSelection.useSelection
                    }
                    onChange={() =>
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        featureSelection: {
                          ...copilotAutoMLConfiguration.featureSelection,
                          useSelection:
                            !copilotAutoMLConfiguration.featureSelection
                              .useSelection,
                        },
                      })
                    }
                  >
                    Use Selection
                  </S2Checkbox>
                </Spacing>
                <Spacing direction="horizontal" size="sm">
                  <label>
                    Huber Loss Delta
                    <NumberInput
                      value={
                        copilotAutoMLConfiguration.autoMlSpecifics
                          .huberLossDelta
                      }
                      onUpdate={(newValue) => {
                        setCopilotAutoMLConfiguration({
                          ...copilotAutoMLConfiguration,
                          autoMlSpecifics: {
                            ...copilotAutoMLConfiguration.autoMlSpecifics,
                            huberLossDelta:
                              newValue ??
                              CopilotAutoMLDefaultCustomConfigurationHuberLossDelta,
                          },
                        });
                      }}
                      placeholder=""
                      showErrorHint={copilotAutoMLConfigurationErrors.some(
                        (e) => e.reason === 'huber-loss-delta-invalid',
                      )}
                    />
                  </label>
                  <label>
                    Robustness Penalty
                    <NumberInput
                      value={
                        copilotAutoMLConfiguration.autoMlSpecifics
                          .robustnessPenalty
                      }
                      onUpdate={(newValue) => {
                        setCopilotAutoMLConfiguration({
                          ...copilotAutoMLConfiguration,
                          autoMlSpecifics: {
                            ...copilotAutoMLConfiguration.autoMlSpecifics,
                            robustnessPenalty:
                              newValue ??
                              CopilotAutoMLDefaultCustomConfigurationRobustnessPenalty,
                          },
                        });
                      }}
                      placeholder=""
                      showErrorHint={copilotAutoMLConfigurationErrors.some(
                        (e) => e.reason === 'robustness-penalty-invalid',
                      )}
                    />
                  </label>
                  <S2Checkbox
                    checked={copilotAutoMLConfiguration.autoMlSpecifics.useRay}
                    onChange={() =>
                      setCopilotAutoMLConfiguration({
                        ...copilotAutoMLConfiguration,
                        autoMlSpecifics: {
                          ...copilotAutoMLConfiguration.autoMlSpecifics,
                          useRay:
                            !copilotAutoMLConfiguration.autoMlSpecifics.useRay,
                        },
                      })
                    }
                  >
                    Use Ray
                  </S2Checkbox>
                </Spacing>
              </Spacing>
            )}
          </Spacing>
        </Box>
        <div>
          <S2Typography variant={'headline-5'} translatedContent={'Copilots'} />
          <AddSchemaSelectionComponent
            possibleValues={CopilotTypes.map((value) => {
              return {
                optionKey: value,
                optionValue: value,
                optionLabel: value,
              };
            })}
            addEntry={(entry) => {
              addCopilotEntry(entry);
            }}
            entryType={'copilot'}
          />
        </div>
        <Spacing size={'md'} direction={'vertical'}>
          <Table
            items={copilotDefinitions.map((value, index) => {
              return {
                ...value,
                index,
              };
            })}
            columnDefinitions={[
              {
                id: 'id',
                header: () => <div>Type</div>,
                cell: ({ item }) => <div>{item.copilotType}</div>,
              },
              {
                id: 'dataSets',
                header: () => <div>Data Sets</div>,
                cell: ({ item }) => {
                  const errMessage =
                    copilotErrors.find(
                      (err) => err.copilotType === item.copilotType,
                    )?.reason ?? '';

                  return (
                    <div>
                      {errMessage.length > 0 && (
                        <div className="text-red-500">{errMessage}</div>
                      )}
                      {item.copilotType === 'hiring' && (
                        <CopilotDataSetSelector
                          dataSetReference={
                            item.externalPayBenchmarkingReference ?? null
                          }
                          setDataSetReference={(
                            newRef: DataSetReference | null,
                          ) => {
                            selectExternalPayBenchmarkingForHiringCopilot(
                              item.index,
                              newRef,
                            );
                          }}
                          organizationId={organizationId}
                          listDataSetVersionsFullPattern={
                            listDataSetVersionsFullPattern
                          }
                          label={'External Pay Benchmarking Data Set'}
                          errors={copilotErrors.filter(
                            (err) => err.copilotType === item.copilotType,
                          )}
                        />
                      )}

                      {item.copilotType === 'pay-benchmarking' && (
                        <CopilotDataSetSelector
                          dataSetReference={
                            item.externalPayBenchmarkingReference ?? null
                          }
                          setDataSetReference={(
                            newRef: DataSetReference | null,
                          ) => {
                            selectExternalPayBenchmarkingForPayBenchmarkingCopilot(
                              item.index,
                              newRef,
                            );
                          }}
                          organizationId={organizationId}
                          listDataSetVersionsFullPattern={
                            listDataSetVersionsFullPattern
                          }
                          label={'External Pay Benchmarking Data Set'}
                          errors={copilotErrors.filter(
                            (err) => err.copilotType === item.copilotType,
                          )}
                        />
                      )}

                      {item.copilotType === 'pay-correction' && (
                        <CopilotDataSetSelector
                          dataSetReference={
                            item.internalPayBenchmarkingReference ?? null
                          }
                          setDataSetReference={(
                            newRef: DataSetReference | null,
                          ) => {
                            selectInternalPayBenchmarkingForPayCorrectionCopilot(
                              item.index,
                              newRef,
                            );
                          }}
                          organizationId={organizationId}
                          listDataSetVersionsFullPattern={
                            listDataSetVersionsFullPattern
                          }
                          label={'Internal Pay Benchmarking Data Set'}
                          errors={copilotErrors.filter(
                            (err) => err.copilotType === item.copilotType,
                          )}
                        />
                      )}
                    </div>
                  );
                },
              },
              {
                id: 'delete',
                header: () => <div>Delete</div>,
                cell: ({ item }) => (
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        deleteColumnEntry(item.index);
                      },
                    }}
                    text={'Delete'}
                  />
                ),
              },
            ]}
          />
        </Spacing>
      </div>
    );
  }, [
    copilotDefinitions,
    language,
    copilotAutoMLConfiguration,
    copilotAutoMLConfigurationErrors,
    addCopilotEntry,
    copilotErrors,
    organizationId,
    listDataSetVersionsFullPattern,
    selectExternalPayBenchmarkingForHiringCopilot,
    selectExternalPayBenchmarkingForPayBenchmarkingCopilot,
    selectInternalPayBenchmarkingForPayCorrectionCopilot,
    deleteColumnEntry,
    setCopilotAutoMLConfiguration,
  ]);
};

export interface CopilotDataSetSelectorHook {
  overlay: React.ReactNode;
  errorNode: React.ReactNode;
  currentNameLabel: string;
  button: React.ReactNode;
}

export const useCopilotDataSetSelector = ({
  dataSetReference,
  setDataSetReference,
  organizationId,
  listDataSetVersionsFullPattern,
  errors,
}: {
  dataSetReference: DataSetReference | null;
  setDataSetReference: Setter<DataSetReference | null>;
  organizationId: string;
  listDataSetVersionsFullPattern: ReadPatternHook<DataSetVersionsFull>;
  errors: DatabaseRevisionSchemaValidationCopilotError[];
}): CopilotDataSetSelectorHook => {
  const [isModalOpen, setModalOpen] = useState(false);

  const onComplete = useCallback(
    (newDataSetReference: DataSetReference) => {
      setDataSetReference(newDataSetReference);
      setModalOpen(false);
    },
    [setDataSetReference],
  );

  const onClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const fullVersionInfo = useMemo(() => {
    if (listDataSetVersionsFullPattern.status !== 'done' || !dataSetReference) {
      return null;
    }

    return (
      listDataSetVersionsFullPattern.entity.fullVersions.find(
        (ver) =>
          ver.dataSet.id === dataSetReference.dataSetId &&
          ver.dataSetVersion.dataSetVersion === dataSetReference.dataSetVersion,
      ) ?? null
    );
  }, [dataSetReference, listDataSetVersionsFullPattern]);

  return useMemo(() => {
    return {
      overlay: isModalOpen &&
        listDataSetVersionsFullPattern.status === 'done' && (
          <DataSetVersionSelectorModal
            dataSetReference={dataSetReference}
            onComplete={onComplete}
            onClose={onClose}
            organizationId={organizationId}
            fullVersions={listDataSetVersionsFullPattern.entity.fullVersions}
          />
        ),
      errorNode: errors.map((err) => {
        return <Paragraph key={err.copilotType}>{err.reason}</Paragraph>;
      }),
      button: (
        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              setModalOpen(true);
            },
          }}
          text={'Select Version'}
          disabled={false}
        />
      ),
      currentNameLabel: fullVersionInfo?.dataSet.displayName ?? '',
    };
  }, [
    dataSetReference,
    errors,
    fullVersionInfo,
    isModalOpen,
    listDataSetVersionsFullPattern,
    onClose,
    onComplete,
    organizationId,
  ]);
};

export const CopilotDataSetSelector = ({
  label,
  errors,
  dataSetReference,
  setDataSetReference,
  organizationId,
  listDataSetVersionsFullPattern,
}: {
  label: string;
  errors: DatabaseRevisionSchemaValidationCopilotError[];
  setDataSetReference: Setter<DataSetReference | null>;
  dataSetReference: DataSetReference | null;
  organizationId: string;
  listDataSetVersionsFullPattern: ReadPatternHook<DataSetVersionsFull>;
}) => {
  const { button, overlay, currentNameLabel, errorNode } =
    useCopilotDataSetSelector({
      setDataSetReference,
      dataSetReference,
      listDataSetVersionsFullPattern,
      organizationId,
      errors,
    });
  return (
    <>
      <Spacing size={'md'} direction={'vertical'}>
        <Paragraph>{label}</Paragraph>

        <Spacing size={'md'} direction={'horizontal'}>
          {button}
          <Paragraph>{currentNameLabel}</Paragraph>
          {errorNode}
        </Spacing>
      </Spacing>
      {overlay}
    </>
  );
};

export const useDatabaseSchemaUpsellPage = ({
  upsellDefinitions,
  deleteColumnEntry,
  addUpsellEntry,
}: {
  upsellDefinitions: UpsellDefinition[];
  updateColumnEntry: (index: number, column: Partial<UpsellDefinition>) => void;
  deleteColumnEntry: (index: number) => void;
  addUpsellEntry: (possibleValue: UpsellType) => void;
  upsellErrors: DatabaseRevisionSchemaValidationUpsellError[];
  organizationId: string;
}): ReactNode => {
  return useMemo(() => {
    return (
      <div>
        <div>
          <AddSchemaSelectionComponent
            possibleValues={UpsellTypes.map((value) => {
              return {
                optionKey: value,
                optionValue: value,
                optionLabel: value,
              };
            })}
            addEntry={(entry) => {
              addUpsellEntry(entry);
            }}
            entryType="Upsell"
          />
        </div>
        <Spacing size={'md'} direction={'vertical'}>
          <Table
            items={upsellDefinitions.map((value, index) => {
              return {
                ...value,
                index,
              };
            })}
            columnDefinitions={[
              {
                id: 'id',
                header: () => <div>Type</div>,
                cell: ({ item }) => <div>{item.type}</div>,
              },
              {
                id: 'delete',
                header: () => <div>Delete</div>,
                cell: ({ item }) => (
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        deleteColumnEntry(item.index);
                      },
                    }}
                    text={'Delete'}
                  />
                ),
              },
            ]}
          />
        </Spacing>
      </div>
    );
  }, [addUpsellEntry, upsellDefinitions, deleteColumnEntry]);
};

const { openaiEnabled } = uiEnvironment;

export const useDatabaseSchemaMiscPage = ({
  possibleDimensionColumns,
  possibleDateColumns,
  metricDefinitions,
  calibrationFraming,
  setCalibrationFraming,
  showAllInsights,
  setShowAllInsights,
  showKeyFactors,
  setShowKeyFactors,
  showGeolocation,
  setShowGeolocation,
  showNewDataIntelligenceDeepDivePage,
  setShowNewDataIntelligenceDeepDivePage,
  showProgressPage,
  setShowProgressPage,
  showSavedAnalysesPage,
  setShowSavedAnalysesPage,
  showRubricsPage,
  setShowRubricsPage,
  showDownloadMultiAnalysisButton,
  setShowDownloadMultiAnalysisButton,
  showDownloadSingleAnalysisButton,
  setShowDownloadSingleAnalysisButton,
  showExplorePage,
  setShowExplorePage,
  sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
  setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
  hiringNotificationEmailSubjectSuffixTemplate,
  setHiringNotificationEmailSubjectSuffixTemplate,
  forceHiringNotificationSummaryToOnlySendToThisEmail,
  setForceHiringNotificationSummaryToOnlySendToThisEmail,
  numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
  setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
  minReadinessRatingForHiringNotificationSummaryEmail,
  setMinReadinessRatingForHiringNotificationSummaryEmail,
  additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
  setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
  enableAtsWriteBack,
  setEnableAtsWriteBack,
  overrideUploadSnapshotDate,
  setOverrideUploadSnapshotDate,
  hideFocusAreaSolutionsPage,
  setHideFocusAreaSolutionsPage,
  hideEmployeeLifecyclePage,
  sethideEmployeeLifecyclePage,
  translationPhrasingCode,
  setTranslationPhrasingCode,
  miscErrors,
  setShowAIExplanations,
  showAIExplanations,
  showDynamicPipelineAnalysisPage,
  setShowDynamicPipelineAnalysisPage,
  showDashboardsPage,
  setShowDashboardsPage,
  showCustomChartTypes,
  setShowCustomChartTypes,
  showFobButtonInDashboardPage,
  setShowFobButtonInDashboardPage,
  showHeatmapAverages,
  setShowHeatmapAverages,
  useDisparityOnRay,
  setUseDisparityOnRay,
  useDisparityOnParquet,
  setUseDisparityOnParquet,
  useHeatmapOnRay,
  setUseHeatmapOnRay,
  useFAOnRay,
  setUseFAOnRay,
  byMetricTrendsConfiguration,
  setByMetricTrendsConfiguration,
  showNewExplanations,
  setShowNewExplanations,
  enablePublicDashboards,
  setEnablePublicDashboards,
  showDashboardAISummaries,
  setShowDashboardAISummaries,
  showChatbot,
  setShowChatbot,
}: {
  possibleDimensionColumns: string[];
  possibleDateColumns: string[];
  metricDefinitions: MetricDefinition[];
  calibrationFraming: CalibrationFraming | null;
  setCalibrationFraming: Setter<CalibrationFraming | null>;
  showAllInsights: boolean;
  setShowAllInsights: Setter<boolean>;
  showAIExplanations: boolean;
  setShowAIExplanations: Setter<boolean>;
  showKeyFactors: boolean;
  setShowKeyFactors: Setter<boolean>;
  showGeolocation: boolean;
  setShowGeolocation: Setter<boolean>;
  showNewDataIntelligenceDeepDivePage: boolean;
  setShowNewDataIntelligenceDeepDivePage: Setter<boolean>;
  showProgressPage: boolean;
  setShowProgressPage: Setter<boolean>;
  showSavedAnalysesPage: boolean;
  setShowSavedAnalysesPage: Setter<boolean>;
  showRubricsPage: boolean;
  setShowRubricsPage: Setter<boolean>;
  showDownloadMultiAnalysisButton: boolean;
  setShowDownloadMultiAnalysisButton: Setter<boolean>;
  showDownloadSingleAnalysisButton: boolean;
  setShowDownloadSingleAnalysisButton: Setter<boolean>;
  showExplorePage: boolean;
  setShowExplorePage: Setter<boolean>;
  sendHiringNotificationSummaryEmailAfterTopLevelAnalysis: boolean;
  setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis: Setter<boolean>;
  hiringNotificationEmailSubjectSuffixTemplate: HiringNotificationEmailSubjectSuffixTemplate;
  setHiringNotificationEmailSubjectSuffixTemplate: Setter<HiringNotificationEmailSubjectSuffixTemplate>;
  forceHiringNotificationSummaryToOnlySendToThisEmail: string | undefined;
  setForceHiringNotificationSummaryToOnlySendToThisEmail: Setter<
    string | undefined
  >;
  numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail:
    | number
    | undefined;
  setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail: Setter<
    number | undefined
  >;
  minReadinessRatingForHiringNotificationSummaryEmail: number | undefined;
  setMinReadinessRatingForHiringNotificationSummaryEmail: Setter<
    number | undefined
  >;
  additionalEmailsToSendAllHiringNotificationSummaryEmailsTo:
    | string[]
    | undefined;
  setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo: Setter<
    undefined | string[]
  >;
  enableAtsWriteBack: boolean | undefined;
  setEnableAtsWriteBack: Setter<boolean | undefined>;
  overrideUploadSnapshotDate: string;
  setOverrideUploadSnapshotDate: Setter<string>;
  hideFocusAreaSolutionsPage: boolean;
  setHideFocusAreaSolutionsPage: Setter<boolean>;
  hideEmployeeLifecyclePage: boolean;
  sethideEmployeeLifecyclePage: Setter<boolean>;
  miscErrors: DatabaseRevisionSchemaValidationMiscError[];
  translationPhrasingCode: LanguageName | undefined;
  setTranslationPhrasingCode: Setter<LanguageName | undefined>;
  showDynamicPipelineAnalysisPage: boolean;
  setShowDynamicPipelineAnalysisPage: Setter<boolean>;
  showDashboardsPage: boolean;
  setShowDashboardsPage: Setter<boolean>;
  showCustomChartTypes: boolean;
  setShowCustomChartTypes: Setter<boolean>;
  showFobButtonInDashboardPage: boolean;
  setShowFobButtonInDashboardPage: Setter<boolean>;
  showHeatmapAverages: boolean;
  setShowHeatmapAverages: Setter<boolean>;
  useDisparityOnRay: boolean;
  setUseDisparityOnRay: Setter<boolean>;
  useDisparityOnParquet: boolean;
  setUseDisparityOnParquet: Setter<boolean>;
  useHeatmapOnRay: boolean;
  setUseHeatmapOnRay: Setter<boolean>;
  useFAOnRay: boolean;
  setUseFAOnRay: Setter<boolean>;
  byMetricTrendsConfiguration: ByMetricTrendsConfig;
  setByMetricTrendsConfiguration: Setter<ByMetricTrendsConfig>;
  showNewExplanations: boolean;
  setShowNewExplanations: Setter<boolean>;
  enablePublicDashboards: boolean;
  setEnablePublicDashboards: Setter<boolean>;
  showDashboardAISummaries: boolean;
  setShowDashboardAISummaries: Setter<boolean>;
  showChatbot: boolean;
  setShowChatbot: Setter<boolean>;
}): ReactNode => {
  const language = useLanguage();

  const hasUploadSnapshotDateError = miscErrors.some(
    (error) => error.reason === 'invalid-override-upload-snapshot-date',
  );

  const possibleTranslationValues = useMemo(() => {
    return LanguageNames.map((language) => {
      return {
        optionKey: language,
        optionLabel: language,
        optionValue: language,
      };
    });
  }, []);

  return (
    <Spacing size={'md'} direction={'vertical'}>
      <Spacing size={'none'} direction={'vertical'}>
        <Paragraph>Calibration Framing:</Paragraph>
        <SelectBoxWithSearch
          type="single"
          selected={calibrationFraming ?? 'bias'}
          setSelected={(f) => {
            setCalibrationFraming(f);
          }}
          list={CalibrationFramings.map((f) => {
            return {
              optionValue: f,
              optionLabel: f,
            };
          })}
          label={'Select Calibration Framing'}
        />
      </Spacing>

      <S2Checkbox
        checked={showAllInsights}
        disabled={false}
        onChange={() => {
          setShowAllInsights(!showAllInsights);
        }}
      >
        Show All Insights
      </S2Checkbox>

      <S2Checkbox
        checked={!hideFocusAreaSolutionsPage}
        disabled={false}
        onChange={() => {
          setHideFocusAreaSolutionsPage(!hideFocusAreaSolutionsPage);
        }}
      >
        Show Focus Area Solutions Page
      </S2Checkbox>

      <S2Checkbox
        checked={!hideEmployeeLifecyclePage}
        disabled={false}
        onChange={() => {
          sethideEmployeeLifecyclePage(!hideEmployeeLifecyclePage);
        }}
      >
        Show Employee Lifecycle
      </S2Checkbox>

      {openaiEnabled && (
        <S2Checkbox
          checked={showAIExplanations}
          disabled={false}
          onChange={() => {
            setShowAIExplanations(!showAIExplanations);
          }}
        >
          Show AI Explanations
        </S2Checkbox>
      )}

      <S2Checkbox
        checked={showNewDataIntelligenceDeepDivePage}
        disabled={false}
        onChange={() => {
          setShowNewDataIntelligenceDeepDivePage(
            !showNewDataIntelligenceDeepDivePage,
          );
        }}
      >
        Show New Data Intelligence Deep Dive Page
      </S2Checkbox>

      <S2Checkbox
        checked={showProgressPage}
        disabled={false}
        onChange={() => {
          setShowProgressPage(!showProgressPage);
        }}
      >
        Show Disparity Trends
      </S2Checkbox>

      <S2Checkbox
        checked={showExplorePage}
        disabled={false}
        onChange={() => {
          setShowExplorePage(!showExplorePage);
        }}
      >
        Show Explore Heatmap Section
      </S2Checkbox>

      <S2Checkbox
        checked={showSavedAnalysesPage}
        disabled={false}
        onChange={() => {
          setShowSavedAnalysesPage(!showSavedAnalysesPage);
        }}
      >
        Show saved analyses page
      </S2Checkbox>

      <S2Checkbox
        checked={showRubricsPage}
        disabled={false}
        onChange={() => {
          setShowRubricsPage(!showRubricsPage);
        }}
      >
        Show Rubrics page
      </S2Checkbox>

      <S2Checkbox
        checked={showDownloadMultiAnalysisButton}
        disabled={false}
        onChange={() => {
          setShowDownloadMultiAnalysisButton(!showDownloadMultiAnalysisButton);
        }}
      >
        Show multi analysis download button
      </S2Checkbox>

      <S2Checkbox
        checked={showDownloadSingleAnalysisButton}
        disabled={false}
        onChange={() => {
          setShowDownloadSingleAnalysisButton(
            !showDownloadSingleAnalysisButton,
          );
        }}
      >
        Show single analysis download button
      </S2Checkbox>

      <S2Checkbox
        checked={showDynamicPipelineAnalysisPage}
        disabled={false}
        onChange={() => {
          setShowDynamicPipelineAnalysisPage(!showDynamicPipelineAnalysisPage);
        }}
      >
        Show dynamic pipeline analysis page
      </S2Checkbox>

      <S2Checkbox
        checked={showDashboardsPage}
        disabled={false}
        onChange={() => {
          setShowDashboardsPage(!showDashboardsPage);
        }}
      >
        Show dashboards page
      </S2Checkbox>

      <S2Checkbox
        checked={showCustomChartTypes}
        disabled={false}
        onChange={() => {
          setShowCustomChartTypes(!showCustomChartTypes);
        }}
      >
        Show custom chart types in dashboards
      </S2Checkbox>

      <S2Checkbox
        checked={showFobButtonInDashboardPage}
        disabled={false}
        onChange={() => {
          setShowFobButtonInDashboardPage(!showFobButtonInDashboardPage);
        }}
      >
        Show FOB button in dashboard details page
      </S2Checkbox>

      <S2Checkbox
        checked={showHeatmapAverages}
        disabled={false}
        onChange={() => {
          setShowHeatmapAverages(!showHeatmapAverages);
        }}
      >
        Show heatmap averages
      </S2Checkbox>

      <S2Checkbox
        checked={useDisparityOnRay}
        disabled={false}
        onChange={() => {
          setUseDisparityOnRay(!useDisparityOnRay);
        }}
      >
        Run Disparities on Ray
      </S2Checkbox>

      <S2Checkbox
        checked={useDisparityOnParquet}
        disabled={!useDisparityOnRay}
        onChange={() => {
          setUseDisparityOnParquet(!useDisparityOnParquet);
        }}
      >
        Run Disparities on Parquet
      </S2Checkbox>

      <S2Checkbox
        checked={useHeatmapOnRay}
        disabled={false}
        onChange={() => {
          setUseHeatmapOnRay(!useHeatmapOnRay);
        }}
      >
        Run Heatmap on Ray
      </S2Checkbox>

      <S2Checkbox
        checked={useFAOnRay}
        disabled={false}
        onChange={() => {
          setUseFAOnRay(!useFAOnRay);
        }}
      >
        Run Bias Tests on Ray
      </S2Checkbox>

      <HiringNotificationSenderConfiguration
        sendHiringNotificationSummaryEmailAfterTopLevelAnalysis={
          sendHiringNotificationSummaryEmailAfterTopLevelAnalysis
        }
        setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis={
          setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis
        }
        forceHiringNotificationSummaryToOnlySendToThisEmail={
          forceHiringNotificationSummaryToOnlySendToThisEmail
        }
        setForceHiringNotificationSummaryToOnlySendToThisEmail={
          setForceHiringNotificationSummaryToOnlySendToThisEmail
        }
        additionalEmailsToSendAllHiringNotificationSummaryEmailsTo={
          additionalEmailsToSendAllHiringNotificationSummaryEmailsTo
        }
        setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo={
          setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo
        }
        minReadinessRatingForHiringNotificationSummaryEmail={
          minReadinessRatingForHiringNotificationSummaryEmail
        }
        setMinReadinessRatingForHiringNotificationSummaryEmail={
          setMinReadinessRatingForHiringNotificationSummaryEmail
        }
        numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail={
          numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail
        }
        setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail={
          setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail
        }
        hiringNotificationEmailSubjectSuffixTemplate={
          hiringNotificationEmailSubjectSuffixTemplate
        }
        setHiringNotificationEmailSubjectSuffixTemplate={
          setHiringNotificationEmailSubjectSuffixTemplate
        }
        enableAtsWriteBack={enableAtsWriteBack}
        setEnableAtsWriteBack={setEnableAtsWriteBack}
      />

      <S2Checkbox
        checked={showNewExplanations}
        disabled={false}
        onChange={() => {
          setShowNewExplanations(!showNewExplanations);
        }}
      >
        Show New Explanations (for Heatmap & Trends)
      </S2Checkbox>

      <S2Checkbox
        checked={enablePublicDashboards}
        disabled={false}
        onChange={() => {
          setEnablePublicDashboards(!enablePublicDashboards);
        }}
      >
        Enable public dashboards
      </S2Checkbox>

      <S2Checkbox
        checked={showDashboardAISummaries}
        disabled={false}
        onChange={() => {
          setShowDashboardAISummaries(!showDashboardAISummaries);
        }}
      >
        Show Dashboard AI Summaries
        {showDashboardAISummaries &&
          (!showDownloadMultiAnalysisButton || !showCustomChartTypes) && (
            <S2Typography
              variant={'body-7'}
              translatedContent={
                '(Required dependencies: Show multi analysis download button + Show custom chart types in dashboards)'
              }
              dangerouslyOverrideClassNameFn={replaceTextColor(
                'inline ml-2 text-red-700',
              )}
            />
          )}
      </S2Checkbox>

      <S2Checkbox
        checked={showChatbot}
        disabled={false}
        onChange={() => {
          setShowChatbot(!showChatbot);
        }}
      >
        Show Chatbot
      </S2Checkbox>

      <Spacing direction="vertical" size="sm">
        <div className="max-w-fit">
          <Switch
            checked={showKeyFactors}
            onChange={() => {
              setShowKeyFactors(!showKeyFactors);
            }}
          >
            Enable Key Factors
          </Switch>
        </div>
      </Spacing>

      <Spacing direction="vertical" size="sm">
        <div className="max-w-fit">
          <Switch
            checked={showGeolocation}
            onChange={() => {
              setShowGeolocation(!showGeolocation);
            }}
          >
            Enable Geolocation
          </Switch>
        </div>
      </Spacing>

      <Spacing size="none" direction="vertical">
        <S2Typography
          variant={'headline-7'}
          translatedContent={language.translationPhrasing()}
        />
        <SchemaSelectionComponent
          possibleValues={possibleTranslationValues}
          selectedValueKey={translationPhrasingCode ?? null}
          setSelectedValue={(_, value) => {
            setTranslationPhrasingCode(value ? value : undefined);
          }}
        />
      </Spacing>

      <Spacing size="none" direction="vertical">
        <S2Typography
          variant={'headline-7'}
          translatedContent={language.uploadSnapshotDateOverride()}
        />
        {hasUploadSnapshotDateError && (
          <S2Typography
            variant={'body-7'}
            translatedContent={language.invalidUploadSnapshotDateFormat()}
            dangerouslyOverrideClassNameFn={replaceTextColor('text-red-700')}
          />
        )}
        <input
          type="text"
          className="form-input"
          value={overrideUploadSnapshotDate}
          onChange={(e) => {
            setOverrideUploadSnapshotDate(e.target.value);
          }}
          placeholder={'YYYY-MM-DD'}
        />
      </Spacing>

      <ByMetricTrendsConfigurationComponent
        possibleDateColumns={possibleDateColumns}
        possibleDimensionColumns={possibleDimensionColumns}
        metricDefinitions={metricDefinitions}
        byMetricTrendsConfiguration={byMetricTrendsConfiguration}
        setByMetricTrendsConfiguration={setByMetricTrendsConfiguration}
      />
    </Spacing>
  );
};

export const useSimpleDatabaseByIdReadPattern = ({
  organizationId,
  databaseId,
}: {
  organizationId: string;
  databaseId: string;
}) => {
  const getUrlFn = useCallback(
    () =>
      `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}`,
    [organizationId, databaseId],
  );
  return useSimpleReadPattern({
    getUrlFn,
    canRead: true,
    responseSchema: Database,
  });
};

interface EditingDynamicPipelineAnalysisConfiguration
  extends DynamicPipelineAnalysisConfiguration {
  index: number;
}

export const useDatabaseSchemaDynamicPipelineAnalysisConfigPage = ({
  pipelineConfigs,
  onUpdatePipelineConfigs,
  focusAreaDefinitions,
  filterSets,
}: {
  pipelineConfigs: DynamicPipelineAnalysisConfiguration[];
  onUpdatePipelineConfigs: (
    pipelineConfigs: DynamicPipelineAnalysisConfiguration[],
  ) => void;
  focusAreaDefinitions: FocusAreaDefinition[];
  filterSets: FilterSetDefinitions;
}) => {
  const language = useLanguage();

  const metricsDisplayNameMap = useMemo(() => {
    if (!focusAreaDefinitions) return {};

    const metricDefinitions = focusAreaDefinitions.flatMap((fA) => fA.metrics);

    const metricEntries = metricDefinitions.map((metric) => [
      metric.columnHeaderValue,
      metric.displayName,
    ]);

    return Object.fromEntries(metricEntries);
  }, [focusAreaDefinitions]);

  const [editingPipelineConfig, setEditingPipelineConfig] =
    useState<EditingDynamicPipelineAnalysisConfiguration | null>(null);

  const editingErrors = useMemo(() => {
    if (!editingPipelineConfig)
      return {
        isMissingName: false,
        isMissingFirstPhaseName: false,
        nameAlreadyExists: false,
        duplicatedMetrics: false,
        hasZeroPhases: false,
      };

    const isMissingName = !getPhrasesWithoutParams(language).includes(
      editingPipelineConfig.name,
    );

    const isMissingFirstPhaseName = !editingPipelineConfig.firstPhaseName;

    const hasZeroPhases = editingPipelineConfig.phases?.length === 0;

    const configWithSameName = pipelineConfigs.find(
      (config, index) =>
        index !== editingPipelineConfig.index &&
        config.name === editingPipelineConfig.name,
    );

    const selectedMetrics = editingPipelineConfig.phases.map(
      (phase) => phase.metric,
    );

    const duplicatedMetrics =
      new Set(selectedMetrics).size !== editingPipelineConfig.phases.length;

    return {
      nameAlreadyExists: configWithSameName !== undefined,
      duplicatedMetrics,
      isMissingName,
      isMissingFirstPhaseName,
      hasZeroPhases,
    };
  }, [editingPipelineConfig, language, pipelineConfigs]);

  const addPipelineConfig = useCallback(() => {
    onUpdatePipelineConfigs([
      ...pipelineConfigs,
      {
        name: `new_pipeline_config_${pipelineConfigs.length}`,
        firstPhaseName: '',
        phases: [],
      },
    ]);
  }, [pipelineConfigs, onUpdatePipelineConfigs]);

  const navigateToEditPipelineConfigurationPage = useCallback(
    (index: number) => {
      if (index < 0 || index > pipelineConfigs.length) {
        return;
      }

      setEditingPipelineConfig({
        index,
        ...pipelineConfigs[index],
      });
    },
    [pipelineConfigs],
  );

  const deletePipelineConfig = useCallback(
    (rowIndex: number) => {
      onUpdatePipelineConfigs(
        pipelineConfigs.filter((_, index) => index !== rowIndex),
      );
    },
    [onUpdatePipelineConfigs, pipelineConfigs],
  );

  const savePipelineConfiguration = useCallback(() => {
    if (!editingPipelineConfig) return;

    const updatedConfigurations = pipelineConfigs.map((config, index) =>
      index === editingPipelineConfig.index ? editingPipelineConfig : config,
    );
    onUpdatePipelineConfigs(updatedConfigurations);
    setEditingPipelineConfig(null);
  }, [editingPipelineConfig, onUpdatePipelineConfigs, pipelineConfigs]);

  const updatePhase = useCallback(
    (rowIndex: number, value: Partial<DynamicPipelineAnalysisPhase>) => {
      if (editingPipelineConfig) {
        setEditingPipelineConfig({
          ...editingPipelineConfig,
          phases: editingPipelineConfig.phases.map((phase, index) =>
            index === rowIndex
              ? {
                  ...phase,
                  ...value,
                }
              : phase,
          ),
        });
      }
    },
    [editingPipelineConfig],
  );

  if (!focusAreaDefinitions) return null;

  if (!editingPipelineConfig) {
    return (
      <div>
        <S2Typography
          variant={'headline-3'}
          translatedContent={language.pipelineAnalysisConfigurations()}
        />

        <Spacing direction={'vertical'} size={'md'}>
          <Button
            behavior={{
              type: 'onClick',
              onClick: addPipelineConfig,
            }}
          >
            Add Pipeline Configuration
          </Button>
          <Table
            items={pipelineConfigs}
            columnDefinitions={[
              {
                id: 'name',
                header: () => <div>Name</div>,
                cell: ({ item }) => {
                  return <div>{item.name}</div>;
                },
              },
              {
                id: 'phases',
                header: () => <div>Phases</div>,
                cell: ({ item }) => {
                  const metrics = item.phases.map(({ metric }) => {
                    return metricsDisplayNameMap[metric] ?? metric;
                  });
                  return <div>{metrics.join(', ')}</div>;
                },
              },
              {
                id: 'edit',
                header: () => <div>Edit</div>,
                cell: ({ rowIndex }) => (
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        navigateToEditPipelineConfigurationPage(rowIndex);
                      },
                    }}
                  >
                    Edit
                  </Button>
                ),
              },
              {
                id: 'delete',
                header: () => <div>Delete</div>,
                cell: ({ rowIndex }) => (
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => deletePipelineConfig(rowIndex),
                    }}
                  >
                    Delete
                  </Button>
                ),
              },
            ]}
          />
        </Spacing>
      </div>
    );
  }

  return (
    editingPipelineConfig && (
      <Spacing direction={'vertical'} size={'md'} className="mb-20">
        <Spacing direction={'horizontal'} size={'md'}>
          <Button
            behavior={{
              type: 'onClick',
              onClick: () => {
                setEditingPipelineConfig(null);
              },
            }}
          >
            Cancel (Back to pipeline configurations)
          </Button>

          <Button
            behavior={{
              type: 'onClick',
              onClick: savePipelineConfiguration,
            }}
            disabled={Object.values(editingErrors).some(Boolean)}
          >
            Save Pipeline Configuration Changes
          </Button>
        </Spacing>

        {editingErrors.isMissingName && (
          <div className={'text-red-500'}>
            Please select a name for this analysis
          </div>
        )}

        {editingErrors.isMissingFirstPhaseName && (
          <div className={'text-red-500'}>
            Please select a name for the first phase
          </div>
        )}

        {editingErrors.nameAlreadyExists && (
          <div className={'text-red-500'}>
            This name already exists on a different pipeline configuration.
          </div>
        )}
        <Spacing direction={'horizontal'} size={'md'}>
          <div data-testid="analysis-name">
            <span>Pipeline Name</span>
            <TranslationSelectionComponent
              value={editingPipelineConfig.name}
              onChange={(value) => {
                setEditingPipelineConfig({
                  ...editingPipelineConfig,
                  name: value,
                });
              }}
            />
          </div>
          <div data-testid="first-phase-name">
            <span>First Phase Name</span>
            <TranslationSelectionComponent
              value={editingPipelineConfig.firstPhaseName}
              onChange={(value) => {
                setEditingPipelineConfig({
                  ...editingPipelineConfig,
                  firstPhaseName: value,
                });
              }}
              onCustomValueChange={(value) => {
                setEditingPipelineConfig({
                  ...editingPipelineConfig,
                  customFirstPhaseName: value,
                });
              }}
              customValue={editingPipelineConfig.customFirstPhaseName}
            />
          </div>
          <div data-testid="filterset-name">
            <span>Filter set</span>
            <SchemaSelectionComponent
              possibleValues={filterSets.map((fS) => {
                return {
                  optionKey: fS.filterSetName,
                  optionValue: fS.filterSetName,
                  optionLabel: fS.filterSetName,
                };
              })}
              selectedValueKey={editingPipelineConfig.filterSetName ?? null}
              setSelectedValue={(key, value) => {
                if (key && value) {
                  setEditingPipelineConfig({
                    ...editingPipelineConfig,
                    filterSetName: value,
                  });
                }
              }}
            />
          </div>
        </Spacing>
        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              const defaultFocusArea = focusAreaDefinitions[0];

              if (!defaultFocusArea) {
                return;
              }

              setEditingPipelineConfig({
                ...editingPipelineConfig,
                phases: [
                  ...editingPipelineConfig.phases,
                  {
                    focusArea: defaultFocusArea.focusArea,
                    metric:
                      defaultFocusArea.metrics[0]?.columnHeaderValue ?? '',
                    positiveTranslation: '',
                    negativeTranslation: '',
                    negativeResultHasNextPhase: true,
                    customPositiveTranslation: '',
                    customNegativeTranslation: '',
                  },
                ],
              });
            },
          }}
        >
          Add phase
        </Button>

        {editingErrors.hasZeroPhases && (
          <div className={'text-red-500'}>
            Please add at least on metric to the analysis.
          </div>
        )}
        {editingErrors.duplicatedMetrics && (
          <div className={'text-red-500'}>
            A metric may only be used for one phase.
          </div>
        )}
        <Table
          items={editingPipelineConfig.phases}
          columnDefinitions={[
            {
              id: 'focusArea',
              header: () => <div>Focus Area</div>,
              cell: ({ item, rowIndex }) => {
                return (
                  <div data-testid={`focus-area-${rowIndex}`}>
                    <SchemaSelectionComponent
                      possibleValues={focusAreaDefinitions.map((fA) => {
                        return {
                          optionKey: fA.focusArea,
                          optionValue: fA,
                          optionLabel: fA.focusArea,
                        };
                      })}
                      selectedValueKey={item.focusArea ?? null}
                      setSelectedValue={(key, value) => {
                        if (key && value) {
                          updatePhase(rowIndex, {
                            focusArea: FocusArea.parse(key),
                            metric: value.metrics[0].columnHeaderValue ?? '',
                          });
                        }
                      }}
                    />
                  </div>
                );
              },
            },
            {
              id: 'metric',
              header: () => <div>Metric</div>,
              cell: ({ item, rowIndex }) => {
                const selectedFocusArea = focusAreaDefinitions.find(
                  (fA) => fA.focusArea === item.focusArea,
                );
                return (
                  selectedFocusArea && (
                    <div data-testid={`metric-${rowIndex}`}>
                      <SchemaSelectionComponent
                        possibleValues={selectedFocusArea.metrics.map(
                          (metric) => {
                            return {
                              optionKey: metric.columnHeaderValue,
                              optionValue: metric.columnHeaderValue,
                              optionLabel: metric.displayName,
                            };
                          },
                        )}
                        selectedValueKey={item.metric ?? null}
                        setSelectedValue={(_, value) => {
                          if (value) {
                            updatePhase(rowIndex, { metric: value });
                          }
                        }}
                      />
                    </div>
                  )
                );
              },
            },
            {
              id: 'positiveTranslation',
              header: () => <div>Positive Translation</div>,
              cell: ({ item, rowIndex }) => (
                <div data-testid={`positive-translation-${rowIndex}`}>
                  <TranslationSelectionComponent
                    value={item.positiveTranslation}
                    onChange={(value) => {
                      updatePhase(rowIndex, { positiveTranslation: value });
                    }}
                    onCustomValueChange={(value) => {
                      updatePhase(rowIndex, {
                        customPositiveTranslation: value,
                      });
                    }}
                    customValue={item.customPositiveTranslation}
                  />
                </div>
              ),
            },
            {
              id: 'negativeTranslation',
              header: () => <div>Negative Translation</div>,
              cell: ({ item, rowIndex }) => (
                <div data-testid={`negative-translation-${rowIndex}`}>
                  <TranslationSelectionComponent
                    value={item.negativeTranslation}
                    onChange={(value) => {
                      updatePhase(rowIndex, { negativeTranslation: value });
                    }}
                    onCustomValueChange={(value) => {
                      updatePhase(rowIndex, {
                        customNegativeTranslation: value,
                      });
                    }}
                    customValue={item.customNegativeTranslation}
                  />
                </div>
              ),
            },
            {
              id: 'negativeResultHasNextPhase',
              header: () => <div>Negative result has next phase</div>,
              cell: ({ item, rowIndex }) => (
                <div data-testid={`next-phase-check-${rowIndex}`}>
                  <S2Checkbox
                    checked={item.negativeResultHasNextPhase ?? false}
                    disabled={false}
                    onChange={() => {
                      updatePhase(rowIndex, {
                        negativeResultHasNextPhase:
                          !item.negativeResultHasNextPhase,
                      });
                    }}
                  >
                    <></>
                  </S2Checkbox>
                </div>
              ),
            },
            {
              id: 'delete',
              header: () => <div>Delete</div>,
              cell: ({ rowIndex }) => (
                <Button
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      setEditingPipelineConfig({
                        ...editingPipelineConfig,
                        phases: editingPipelineConfig.phases.filter(
                          (_, index) => index !== rowIndex,
                        ),
                      });
                    },
                  }}
                >
                  Delete
                </Button>
              ),
            },
          ]}
        />
      </Spacing>
    )
  );
};

export const DatabaseSchemaDimensionLevelsPage = ({
  levels,
  onSave,
  onBack,
}: {
  levels: LevelDefinition[];
  onSave: (levelConfig: LevelDefinition[]) => void;
  onBack: () => void;
}) => {
  const [currentLevels, setCurrentLevels] = useState(levels);

  const updateColumnValue = useCallback(
    (index: number, column: Partial<LevelDefinition>) => {
      setCurrentLevels((prevState) => {
        const newState = [...prevState];
        newState[index] = {
          ...newState[index],
          ...column,
        };
        return newState;
      });
    },
    [],
  );

  const onPositionChange = useCallback(
    ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
      setCurrentLevels((prevState) => {
        const newState = [...prevState];
        const item = newState[oldIndex];
        newState.splice(oldIndex, 1);
        newState.splice(newIndex, 0, item);
        return newState;
      });
    },
    [],
  );

  const items = currentLevels.map((level, index) => {
    return {
      ...level,
      index: index,
    };
  });

  return (
    <div>
      <Heading level={4}>Edit Level</Heading>

      <Spacing size="sm" direction="horizontal">
        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              onBack();
            },
          }}
          text={'Back'}
        />

        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              onSave([...currentLevels]);
            },
          }}
          text={'Save Levels'}
        />
      </Spacing>

      <Table
        items={items}
        columnDefinitions={[
          {
            id: 'id',
            header: () => <div>Id</div>,
            cell: ({ item }) => <div>{item.columnValue}</div>,
          },
          {
            id: 'position',
            header: () => <div>Position</div>,
            cell: ({ item }) => (
              <Spacing direction="horizontal" size="md">
                <Button
                  size="small"
                  variant="outline"
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      onPositionChange({
                        oldIndex: item.index,
                        newIndex: item.index + 1,
                      });
                    },
                  }}
                >
                  <IconArrowDownSvg
                    svg={{ className: 'w-4 h-4' }}
                    aria-label="Move down"
                  />
                </Button>

                <Button
                  size="small"
                  variant="outline"
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      onPositionChange({
                        oldIndex: item.index,
                        newIndex: item.index - 1,
                      });
                    },
                  }}
                >
                  <IconArrowDownSvg
                    svg={{ className: 'w-4 h-4 rotate-180' }}
                    aria-label="Move up"
                  />
                </Button>
              </Spacing>
            ),
          },
          {
            id: 'name',
            header: () => <div>Name</div>,
            cell: ({ item }) => (
              <input
                type="text"
                className="form-input"
                key={' name'}
                value={item.displayName}
                aria-label={'name'}
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    displayName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'displayColor',
            header: () => <div>Display Color</div>,
            cell: ({ item }) => (
              <select
                value={item.color}
                aria-label={'displayColor'}
                className="form-select w-full"
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    color: event.target.value as Color,
                  });
                }}
              >
                {Colors.map((option) => {
                  return (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  );
                })}
              </select>
            ),
          },
          {
            id: 'displayIcon',
            header: () => <div>Display Icon</div>,
            cell: ({ item }) => (
              <select
                value={item.icon}
                aria-label={'displayIcon'}
                className="form-select w-full"
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    icon: event.target.value as Icon,
                  });
                }}
              >
                {Icons.map((option) => {
                  return (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  );
                })}
              </select>
            ),
          },
          {
            id: 'isPrivileged',
            header: () => <div>Is Privileged</div>,
            cell: ({ item }) => (
              <input
                type="checkbox"
                className="form-checkbox"
                checked={item.isPrivileged}
                aria-label={'isPrivileged'}
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    isPrivileged: event.target.checked,
                  });
                }}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export const DatabaseSchemaFocusAreaControlVariablesPage = ({
  controlVariables,
  possibleValues,
  onSave,
  onBack,
  uniqueValuesByColumn,
  dateColumns,
  numericColumns,
}: {
  focusAreaName: string;
  controlVariables: ControlVariableDefinition[];
  onSave: (controlVariables: ControlVariableDefinition[]) => void;
  onBack: () => void;
  possibleValues: string[];
  uniqueValuesByColumn: TransformInsights['uniqueValuesByColumn'];
  numericColumns: TransformInsights['numericColumns'];
  dateColumns: TransformInsights['dateColumns'];
}) => {
  const [currentControlVariables, setCurrentControlVariables] =
    useState(controlVariables);

  const [
    currentlyEditingCategoricalSortOrderIndex,
    setCurrentlyEditingCategoricalSortOrderIndex,
  ] = useState<number | null>(null);

  const [draftCategoricalSortOrder, setCategoricalDraftSortOrder] = useState<
    string[] | null
  >(null);

  const updateColumnValue = useCallback(
    (index: number, column: Partial<ControlVariableDefinition>) => {
      setCurrentControlVariables((prevState) => {
        const newState = [...prevState];

        newState[index] = {
          ...newState[index],
          ...column,
        };

        return newState;
      });
    },
    [],
  );

  const updateNumericalTraitDefinitionColumnValue = useCallback(
    (
      index: number,
      column: Partial<
        NonNullable<ControlVariableDefinition['numericalTraitDefinition']>
      >,
    ) => {
      setCurrentControlVariables((prevState) => {
        const newState = [...prevState];
        newState[index] = {
          ...newState[index],
          numericalTraitDefinition: {
            ...(newState[index]?.numericalTraitDefinition ??
              numericalTraitDefinition()),
            ...column,
          },
        };
        return newState;
      });
    },
    [],
  );

  const onExecuteSave = useCallback(() => {
    onSave(currentControlVariables);
  }, [currentControlVariables, onSave]);

  return (
    <div className="overflow-x-auto">
      {currentlyEditingCategoricalSortOrderIndex === null && (
        <>
          <Heading level={4}>Edit Control Variables</Heading>
          <AddSchemaSelectionComponent
            label={'control variable'}
            possibleValues={possibleValues.map((value) => {
              return {
                optionKey: value,
                optionValue: value,
                optionLabel: value,
              };
            })}
            addEntry={(entry) => {
              setCurrentControlVariables((prevState) => {
                return [
                  ...prevState,
                  {
                    columnHeaderValue: entry,
                    displayName: entry,
                    dataType: Boolean(numericColumns?.[entry])
                      ? 'numeric'
                      : 'categorical',
                    transformationType: 'none',
                    numericalTraitDefinition: numericalTraitDefinition(),
                    placesToHide: [],
                  },
                ];
              });
            }}
            entryType="Control Variable"
          />

          <Spacing size="sm" direction="horizontal">
            <Button
              behavior={{
                type: 'onClick',
                onClick: () => {
                  onBack();
                },
              }}
              text={'Back'}
            />

            <Button
              behavior={{
                type: 'onClick',
                onClick: () => {
                  onExecuteSave();
                },
              }}
              text={'Save Control Variables'}
            />
          </Spacing>
          <Table
            items={currentControlVariables.map((level, index) => {
              return {
                ...level,
                index: index,
              };
            })}
            columnDefinitions={[
              {
                id: 'id',
                header: () => <div>Variable</div>,
                cell: ({ item }) => <div>{item.columnHeaderValue}</div>,
              },
              {
                id: 'displayName',
                header: () => <div>Name</div>,
                cell: ({ item }) => (
                  <input
                    type="text"
                    className="form-input"
                    key={' name'}
                    value={item.displayName}
                    aria-label={'name'}
                    onChange={(e) => {
                      updateColumnValue(item.index, {
                        displayName: e.target.value,
                      });
                    }}
                  />
                ),
              },
              {
                id: 'dataType',
                header: () => <div>Data Type</div>,
                cell: ({ item }) => {
                  const shouldProbablyBeNumeric = Boolean(
                    numericColumns?.[item.columnHeaderValue],
                  );

                  const showWarning =
                    shouldProbablyBeNumeric && item.dataType === 'categorical';

                  return (
                    <>
                      <SchemaSelectionComponent
                        label={'data type'}
                        possibleValues={ControlVariableDataTypes.map(
                          (value) => {
                            return {
                              optionKey: value,
                              optionValue: value,
                              optionLabel: value,
                            };
                          },
                        )}
                        selectedValueKey={item.dataType}
                        setSelectedValue={(_, value) => {
                          updateColumnValue(item.index, {
                            dataType: value ?? undefined,
                          });
                        }}
                      />

                      {showWarning && (
                        <div className="mt-1 flex items-start gap-1 text-xs text-yellow-700 bg-yellow-50 border border-yellow-200 rounded px-2 py-1">
                          <svg
                            className="h-4 w-4 flex-shrink-0 mt-0.5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span>
                            This column appears to be numeric but is set to
                            categorical
                          </span>
                        </div>
                      )}
                    </>
                  );
                },
              },
              {
                id: 'categoricalSortOrder',
                header: () => <div>Categorical Sort Order</div>,
                cell: ({ item, rowIndex }) => {
                  if (item.dataType !== 'categorical') {
                    return <>N/A</>;
                  }

                  return (
                    <Button
                      behavior={{
                        type: 'onClick',
                        onClick: () => {
                          const existing =
                            item.categoricalTraitDefinition?.sortOrder;
                          setCurrentlyEditingCategoricalSortOrderIndex(
                            rowIndex,
                          );
                          setCategoricalDraftSortOrder(
                            existing ? [...existing] : null,
                          );
                        },
                      }}
                      text={'Edit Order'}
                    />
                  );
                },
              },
              {
                id: 'transformType',
                header: () => <div>Transformation Type</div>,
                cell: ({ item }) => (
                  <SchemaSelectionComponent
                    label={'transformation type'}
                    possibleValues={ControlVariableTransformationTypes.map(
                      (value) => {
                        return {
                          optionKey: value,
                          optionValue: value,
                          optionLabel: value,
                        };
                      },
                    )}
                    selectedValueKey={item.transformationType}
                    setSelectedValue={(_, value) => {
                      updateColumnValue(item.index, {
                        transformationType: value ?? 'none',
                      });
                    }}
                  />
                ),
              },
              {
                id: 'attributes',
                header: () => <div>Attributes</div>,
                cell: ({ item }) => {
                  return (
                    <AttributesColumn
                      columnHeaderValue={item.columnHeaderValue}
                      uniqueValuesByColumn={uniqueValuesByColumn}
                      numericColumns={numericColumns}
                      dateColumns={dateColumns}
                    />
                  );
                },
              },
              {
                id: 'unitSingular',
                header: () => <div>Unit singular</div>,
                cell: ({ item }) => {
                  if (item.dataType !== 'numeric') {
                    return <p>-</p>;
                  }

                  return (
                    <input
                      aria-label={'unit singular'}
                      type="text"
                      className="form-input"
                      value={item.numericalTraitDefinition?.unitSingular}
                      onChange={(e) => {
                        updateNumericalTraitDefinitionColumnValue(item.index, {
                          unitSingular: e.target.value,
                        });
                      }}
                    />
                  );
                },
              },
              {
                id: 'unitPlural',
                header: () => <div>Unit plural</div>,
                cell: ({ item }) => {
                  if (item.dataType !== 'numeric') {
                    return <p>-</p>;
                  }

                  return (
                    <input
                      aria-label={'unit plural'}
                      type="text"
                      className="form-input"
                      value={item.numericalTraitDefinition?.unitPlural}
                      onChange={(e) => {
                        updateNumericalTraitDefinitionColumnValue(item.index, {
                          unitPlural: e.target.value,
                        });
                      }}
                    />
                  );
                },
              },
              {
                id: 'denominator',
                header: () => <div>Denominator</div>,
                cell: ({ item }) => {
                  if (item.dataType !== 'numeric') {
                    return <p>-</p>;
                  }

                  return (
                    <input
                      aria-label={'denominator'}
                      type="number"
                      min={0.001}
                      className="form-input"
                      value={item.numericalTraitDefinition?.denominator}
                      onChange={(e) => {
                        updateNumericalTraitDefinitionColumnValue(item.index, {
                          denominator: Number(e.target.value),
                        });
                      }}
                    />
                  );
                },
              },
              {
                id: 'description',
                header: () => <div>Description</div>,
                cell: ({ item }) => (
                  <textarea
                    className="form-textarea"
                    key={'description'}
                    value={item.description}
                    aria-label={'description'}
                    onChange={(event) => {
                      updateColumnValue(item.index, {
                        description: event.target.value,
                      });
                    }}
                  />
                ),
              },
              {
                id: 'placesToHide',
                header: () => <div>Places to Hide Variable</div>,
                cellClassNames: () => 'min-w-[200px]',
                cell: ({ item }) => {
                  const validOptionValues =
                    ControlVariablePlacesToHideOptions.map((opt) => opt.value);
                  // Filter to only include valid values to prevent displaying invalid selections
                  const selectedValues = (item.placesToHide ?? []).filter(
                    (val): val is ControlVariablePlaceToHideValue =>
                      validOptionValues.includes(val),
                  );
                  return (
                    <SelectBoxWithSearch<ControlVariablePlaceToHideValue>
                      type={'multi'}
                      list={ControlVariablePlacesToHideOptions.map((option) => {
                        return {
                          optionValue: option.value,
                          optionLabel: option.label,
                        };
                      })}
                      label={'Places to Hide Variable'}
                      selected={selectedValues}
                      setSelected={(newOptions) => {
                        if (typeof newOptions === 'function') {
                          return;
                        }
                        updateColumnValue(item.index, {
                          placesToHide: newOptions,
                        });
                      }}
                    />
                  );
                },
              },
              {
                id: 'Delete',
                header: () => <div>Delete</div>,
                cell: ({ item }) => (
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        setCurrentControlVariables((prevState) => {
                          return prevState.filter(
                            (level) =>
                              level.columnHeaderValue !==
                              item.columnHeaderValue,
                          );
                        });
                      },
                    }}
                    text={'Delete'}
                  ></Button>
                ),
              },
            ]}
          />
        </>
      )}

      {currentlyEditingCategoricalSortOrderIndex !== null && (
        <>
          <Heading level={4}>
            Edit Categorical Sort Order for{' '}
            {currentControlVariables[currentlyEditingCategoricalSortOrderIndex]
              ?.displayName ?? 'N/A'}
          </Heading>

          <CategoricalVariableSortOrderTable
            possibleValues={
              uniqueValuesByColumn.find(
                (c) =>
                  c.columnName ===
                  currentControlVariables[
                    currentlyEditingCategoricalSortOrderIndex
                  ]?.columnHeaderValue,
              )?.uniqueValues ?? []
            }
            draftCategoricalSortOrder={draftCategoricalSortOrder}
            setCategoricalDraftSortOrder={setCategoricalDraftSortOrder}
            onSaveCategoricalSortOrder={(newValues) => {
              setCurrentControlVariables((prevState) => {
                const updated = [...prevState];
                updated[currentlyEditingCategoricalSortOrderIndex] = {
                  ...updated[currentlyEditingCategoricalSortOrderIndex],
                  categoricalTraitDefinition: {
                    ...updated[currentlyEditingCategoricalSortOrderIndex]
                      .categoricalTraitDefinition,
                    sortOrder: newValues ?? undefined,
                  },
                };
                return updated;
              });
              setCurrentlyEditingCategoricalSortOrderIndex(null);
              setCategoricalDraftSortOrder(null);
            }}
            onCancelCategoricalSortOrder={() => {
              setCurrentlyEditingCategoricalSortOrderIndex(null);
              setCategoricalDraftSortOrder(null);
            }}
          />
        </>
      )}
    </div>
  );
};

const CategoricalVariableSortOrderTable = ({
  possibleValues,
  draftCategoricalSortOrder,
  setCategoricalDraftSortOrder,
  onSaveCategoricalSortOrder,
  onCancelCategoricalSortOrder,
}: {
  possibleValues: string[];
  draftCategoricalSortOrder: string[] | null;
  setCategoricalDraftSortOrder: (newValue: string[] | null) => void;
  onSaveCategoricalSortOrder: (newValue: string[] | null) => void;
  onCancelCategoricalSortOrder: () => void;
}) => {
  const effectiveDraftSortOrder: string[] | null = useMemo(() => {
    if (draftCategoricalSortOrder === null) {
      return null;
    }

    // start with the items they already have in draftCategoricalSortOrder
    const effective: string[] = draftCategoricalSortOrder.filter((draftItem) =>
      possibleValues.includes(draftItem),
    );
    // get the rest of the items that are in possibleValues
    const rest: string[] = possibleValues.filter(
      (value) => !effective.includes(value),
    );
    // sort rest in ABC order
    rest.sort();
    return [...effective, ...rest];
  }, [possibleValues, draftCategoricalSortOrder]);

  return (
    <>
      <Spacing size="sm" direction="horizontal">
        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              onCancelCategoricalSortOrder();
            },
          }}
          text={'Back'}
        />

        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              onSaveCategoricalSortOrder(effectiveDraftSortOrder);
            },
          }}
          text={'Apply Order'}
        />
      </Spacing>
      <S2Checkbox
        checked={draftCategoricalSortOrder !== null}
        onChange={() => {
          if (draftCategoricalSortOrder === null) {
            setCategoricalDraftSortOrder([]);
          } else {
            setCategoricalDraftSortOrder(null);
          }
        }}
      >
        Enable Sorting of Variable
      </S2Checkbox>
      {effectiveDraftSortOrder !== null && (
        <Table
          items={effectiveDraftSortOrder.map((controlVariableValue, index) => {
            return {
              controlVariableValue,
              index: index,
            };
          })}
          columnDefinitions={[
            {
              id: 'value',
              header: () => <div>Control Variable Value</div>,
              cell: ({ item }) => <div>{item.controlVariableValue}</div>,
            },
            {
              id: 'controls',
              header: () => <div>Controls</div>,
              cell: ({ item }) => (
                <Spacing direction="horizontal" size="md">
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        // Move item up
                        const newOrder = [...effectiveDraftSortOrder];
                        const [movedItem] = newOrder.splice(item.index, 1);
                        newOrder.splice(item.index - 1, 0, movedItem);
                        setCategoricalDraftSortOrder(newOrder);
                      },
                    }}
                    disabled={item.index === 0}
                    text={'Move Up'}
                  />
                  <Button
                    behavior={{
                      type: 'onClick',
                      onClick: () => {
                        // Move item down
                        const newOrder = [...effectiveDraftSortOrder];
                        const [movedItem] = newOrder.splice(item.index, 1);
                        newOrder.splice(item.index + 1, 0, movedItem);
                        setCategoricalDraftSortOrder(newOrder);
                      },
                    }}
                    disabled={item.index === effectiveDraftSortOrder.length - 1}
                    text={'Move Down'}
                  />
                </Spacing>
              ),
            },
          ]}
        />
      )}
    </>
  );
};

export const DatabaseSchemaFocusAreaMetricsPage = ({
  metrics,
  possibleValues,
  focusAreaDefinition,
  onSave,
  onBack,
  calibrationFraming,
}: {
  focusAreaDefinition: FocusAreaDefinition;
  metrics: MetricDefinition[];
  onSave: (metrics: MetricDefinition[]) => void;
  onBack: () => void;
  possibleValues: string[];
  calibrationFraming: CalibrationFraming;
}) => {
  const language = useLanguage();
  const [currentMetrics, setCurrentMetrics] = useState(metrics);

  const [isWhiteLabelingPopoverOpen, setIsWhiteLabelingPopoverOpen] =
    useState(false);
  const [currentSelectedIndexForPopover, setCurrentSelectedIndexForPopover] =
    useState<number | null>(null);

  const [isWhiteLabelingPreviewPanelOpen, setIsWhiteLabelingPreviewPanelOpen] =
    useState(false);
  const [
    currentSelectedIndexForPreviewPanel,
    setCurrentSelectedIndexForPreviewPanel,
  ] = useState<number | null>(null);

  const currentSelectedMetricDefinitionForPreviewPanel = useMemo(() => {
    if (currentSelectedIndexForPreviewPanel === null) {
      return null;
    }
    return convertMetricDefinitionToMyMetricDefinition({
      metricDefinition: currentMetrics[currentSelectedIndexForPreviewPanel],
      focusAreaDefinition,
      isMetricBoolean: false,
      uniqueValuesByColumn: [],
      filterSetDefinitions: [],
      performanceMetric: null,
      computeStaticControlVars: false,
      // TODO: Pass the task for metrics for the revision draft?
      tasksForMetric: {},
    });
  }, [
    currentMetrics,
    currentSelectedIndexForPreviewPanel,
    focusAreaDefinition,
  ]);

  const updateColumnValue = useCallback(
    (index: number, column: Partial<MetricDefinition>) => {
      setCurrentMetrics((prevState) => {
        const newState = [...prevState];
        newState[index] = {
          ...newState[index],
          ...column,
        };
        return newState;
      });
    },
    [],
  );

  const onExecuteSave = useCallback(() => {
    onSave(currentMetrics);
  }, [currentMetrics, onSave]);

  const possibleCalibrationValues = useMemo(() => {
    return MetricDefinitionCalibrationFramingValues.map((value) => {
      return {
        optionKey: value,
        optionValue: value,
        optionLabel: value,
      };
    });
  }, []);

  const updateWhiteLabeling = useCallback(
    (index: number, column: Partial<MetricDefinitionWhiteLabeling>) => {
      setCurrentMetrics((prevState) => {
        const newState = [...prevState];
        let currentWhiteLabeling = newState[index].whiteLabeling;
        if (!currentWhiteLabeling) {
          currentWhiteLabeling = {
            subjectSingular: '',
            subjectPlural: '',
            subjectPassiveVerb: '',
            subjectConditionalVerb: '',
            proceseesDescription: '',
          };
        }
        newState[index] = {
          ...newState[index],
          whiteLabeling: {
            ...currentWhiteLabeling,
            ...column,
          },
        };
        return newState;
      });
    },
    [],
  );

  return (
    <div>
      {isWhiteLabelingPreviewPanelOpen && (
        <Transition appear show={isWhiteLabelingPreviewPanelOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-overlay"
            onClose={() => setIsWhiteLabelingPreviewPanelOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-1/2 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-12px transition-all">
                    <div>
                      {currentSelectedMetricDefinitionForPreviewPanel && (
                        <DeepDiveOverviewCard
                          treatmentGroupLevelDefinition={{
                            columnValue: 'asian',
                            displayName: 'Asian',
                            isPrivileged: false,
                            icon: 'BlueRoundedTriangleSvg',
                            color: 'Blue',
                          }}
                          referenceGroupLevelDefinition={{
                            columnValue: 'white',
                            displayName: 'White',
                            isPrivileged: false,
                            icon: 'BlueRoundedTriangleSvg',
                            color: 'Blue',
                          }}
                          metricDefinition={
                            currentSelectedMetricDefinitionForPreviewPanel
                          }
                          rawDisparityPercentage={-10}
                          controlledDisparityPercentage={-6}
                          debiasedDisparityPercentage={-3}
                          confidencePercentage={99}
                          numberOfTreatmentGroupSubjects={480}
                          numeratorOfTreatmentGroupSubjects={48}
                          numberOfReferenceGroupSubjects={580}
                          numeratorOfReferenceGroupSubjects={58}
                          controlVariableDisplayNames={[
                            'Experience',
                            'Education',
                          ]}
                          calibrationFraming={calibrationFraming}
                        />
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}
      <Heading level={4}>Edit Metrics</Heading>
      <AddSchemaSelectionComponent
        possibleValues={possibleValues.map((value) => {
          return {
            optionKey: value,
            optionValue: value,
            optionLabel: value,
          };
        })}
        addEntry={(entry) => {
          setCurrentMetrics((prevState) => {
            return [
              ...prevState,
              {
                columnHeaderValue: entry,
                displayName: entry,
                isPreferred: false,
                whiteLabeling: {
                  subjectSingular: '',
                  subjectPlural: '',
                  subjectPassiveVerb: '',
                  subjectConditionalVerb: '',
                  proceseesDescription: '',
                },
                unit: undefined,
              },
            ];
          });
        }}
        entryType="Metric"
      />

      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            onBack();
          },
        }}
        text={'Back'}
      />

      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            onExecuteSave();
          },
        }}
        text={'Save Metrics'}
      />
      <Table
        items={currentMetrics.map((metric, index) => {
          return {
            ...metric,
            index: index,
          };
        })}
        columnDefinitions={[
          {
            id: 'id',
            header: () => <div>Column</div>,
            cell: ({ item }) => <div>{item.columnHeaderValue}</div>,
          },
          {
            id: 'displayName',
            header: () => <div>Display Name</div>,
            cell: ({ item }) => (
              <input
                type="text"
                key={'name'}
                value={item.displayName}
                aria-label={'name'}
                className="form-input"
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    displayName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'isPreferred',
            header: () => <div>Preferred</div>,
            cell: ({ item }) => (
              <input
                type="checkbox"
                checked={item.isPreferred}
                aria-label={'isPreferred'}
                className="form-checkbox"
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    isPreferred: event.target.checked,
                  });
                }}
              />
            ),
          },
          {
            id: 'calibrationFraming',
            header: () => <div>Calibration Framing</div>,
            cell: ({ item }) => (
              <Spacing size={'md'} direction={'vertical'}>
                <SchemaSelectionComponent
                  label={'Framing'}
                  possibleValues={possibleCalibrationValues}
                  selectedValueKey={item.calibrationFraming ?? null}
                  setSelectedValue={(_, value) => {
                    updateColumnValue(item.index, {
                      calibrationFraming: value ?? undefined,
                    });
                  }}
                />
                <SelectBoxWithSearch
                  type="single"
                  selected={calibrationFraming ?? 'bias'}
                  setSelected={() => {}}
                  list={[
                    {
                      optionLabel: 'optimization',
                      optionValue: 'optimization',
                    },
                    { optionLabel: 'bias', optionValue: 'bias' },
                  ]}
                  label={'Calibration Framing'}
                  disabled={true}
                />
              </Spacing>
            ),
          },
          {
            id: 'unit',
            header: () => <div>Unit</div>,
            cell: ({ item }) => (
              <Spacing size={'md'} direction={'vertical'}>
                <SelectBoxWithSearch
                  type="single"
                  selected={item.unit ?? 'none'}
                  setSelected={(newUnit) => {
                    updateColumnValue(item.index, {
                      unit: newUnit === 'none' ? undefined : newUnit,
                    });
                  }}
                  list={[
                    {
                      optionLabel: 'None (auto-detect)',
                      optionValue: 'none',
                    },
                    {
                      optionLabel: 'Percentage (%)',
                      optionValue: 'percentage',
                    },
                    { optionLabel: 'Count (#)', optionValue: 'count' },
                    { optionLabel: 'Dollars ($)', optionValue: 'dollars' },
                  ]}
                  label={'Unit'}
                />
              </Spacing>
            ),
          },
          {
            id: 'whiteLabeling',
            header: () => <div>White Labeling</div>,
            cell: ({ item }) => (
              <Spacing size={'md'} direction={'vertical'}>
                <Popover className="relative">
                  <Popover.Button>
                    <Button
                      behavior={{
                        type: 'onClick',
                        onClick: () => {
                          setIsWhiteLabelingPopoverOpen(
                            !isWhiteLabelingPopoverOpen,
                          );
                          setCurrentSelectedIndexForPopover(item.index);
                        },
                      }}
                    >
                      <S2Typography
                        translatedContent={language.preload()}
                        textColorVariant={'white'}
                        variant={'body-7'}
                      />
                    </Button>
                  </Popover.Button>
                  {isWhiteLabelingPopoverOpen &&
                    currentSelectedIndexForPopover !== null &&
                    item.index === currentSelectedIndexForPopover && (
                      <Popover.Panel static>
                        <div className="absolute bg-white border-1 border-black z-10">
                          {PreloadableMetricDefinitionWhiteLabelTypeValues.map(
                            (type) => {
                              return (
                                <div key={type}>
                                  <TouchTarget
                                    content={({ hovered, disabled }) => {
                                      return (
                                        <div
                                          className={cn({
                                            'p-1': true,
                                            'bg-gray-100': hovered && !disabled,
                                          })}
                                        >
                                          <S2Typography
                                            translatedContent={language.dangerousUserInput(
                                              {
                                                value: type,
                                              },
                                            )}
                                            variant={'body-7'}
                                            textColorVariant={'secondary'}
                                            dangerouslyOverrideClassNameFn={() => {
                                              return cn({
                                                'cursor-pointer':
                                                  hovered && !disabled,
                                              });
                                            }}
                                          />
                                        </div>
                                      );
                                    }}
                                    behavior={{
                                      type: 'onClick',
                                      onClick: () => {
                                        updateWhiteLabeling(item.index, {
                                          ...preloadableMetricDefinitionWhiteLabels[
                                            type
                                          ],
                                        });
                                        setIsWhiteLabelingPopoverOpen(false);
                                        setCurrentSelectedIndexForPopover(null);
                                      },
                                    }}
                                  />
                                </div>
                              );
                            },
                          )}
                        </div>
                      </Popover.Panel>
                    )}
                </Popover>
                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Subject Singular
                    <input
                      type="text"
                      key={'subjectSingular'}
                      className="form-input"
                      value={item.whiteLabeling?.subjectSingular ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          subjectSingular: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>

                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Subject Plural
                    <input
                      type="text"
                      key={'subjectPlural'}
                      className="form-input"
                      value={item.whiteLabeling?.subjectPlural ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          subjectPlural: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>
                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Subject Passive Verb
                    <input
                      type="text"
                      key={'subjectPassiveVerb'}
                      className="form-input"
                      value={item.whiteLabeling?.subjectPassiveVerb ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          subjectPassiveVerb: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>
                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Subject Conditional Verb
                    <input
                      type="text"
                      key={'subjectConditionalVerb'}
                      className="form-input"
                      value={item.whiteLabeling?.subjectConditionalVerb ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          subjectConditionalVerb: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>
                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Processes Description
                    <input
                      type="text"
                      key={'processeDescription'}
                      className="form-input"
                      value={item.whiteLabeling?.proceseesDescription ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          proceseesDescription: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>

                <Spacing size={'md'} direction={'horizontal'}>
                  <label>
                    Event Display Name
                    <input
                      type="text"
                      key={'eventDisplayName'}
                      className="form-input"
                      value={item.whiteLabeling?.eventDisplayName ?? ''}
                      onChange={(event) => {
                        updateWhiteLabeling(item.index, {
                          eventDisplayName: event.target.value,
                        });
                      }}
                    />
                  </label>
                </Spacing>
                <Button
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      setCurrentSelectedIndexForPreviewPanel(item.index);
                      setIsWhiteLabelingPreviewPanelOpen(true);
                    },
                  }}
                  variant={'primary'}
                >
                  <S2Typography
                    variant={'body-7'}
                    translatedContent={language.preview()}
                    textColorVariant={'white'}
                  />
                </Button>
              </Spacing>
            ),
          },
          {
            id: 'description',
            header: () => <div>Description</div>,
            cell: ({ item }) => (
              <textarea
                className="form-textarea"
                key={'description'}
                value={item.description}
                aria-label={'description'}
                role="description"
                onChange={(event) => {
                  updateColumnValue(item.index, {
                    description: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'Delete',
            header: () => <div>Delete</div>,
            cell: ({ item }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    setCurrentMetrics((prevState) => {
                      return prevState.filter(
                        (level) =>
                          level.columnHeaderValue !== item.columnHeaderValue,
                      );
                    });
                  },
                }}
                text={'Delete'}
              ></Button>
            ),
          },
        ]}
      />
    </div>
  );
};

export const DatabaseSchemaFocusAreaToolsPage = ({
  focusArea,
  toolsDefinition,
  filterSets,
  dataIntelligenceDeepDiveIsEnabled,
  onSave,
  onBack,
}: {
  focusArea: FocusArea;
  toolsDefinition: FocusAreaToolsDefinition;
  filterSets: FilterSetDefinitions;
  dataIntelligenceDeepDiveIsEnabled: boolean;
  onSave: (toolsDefinition: FocusAreaToolsDefinition) => void;
  onBack: () => void;
}) => {
  const language = useLanguage();

  const [stagingToolsDefinition, setStagingToolsDefinition] =
    useState<FocusAreaToolsDefinition | null>(null);

  // Set the initial values for tools
  useEffect(() => {
    setStagingToolsDefinition(toolsDefinition);
  }, [toolsDefinition]);

  const validationErrors = useMemo(() => {
    if (!stagingToolsDefinition) {
      return [];
    }

    return getToolsDefinitionValidationErrors({
      toolsDefinition: stagingToolsDefinition,
      filterSets,
      dataIntelligenceDeepDiveIsEnabled,
    });
  }, [stagingToolsDefinition, filterSets, dataIntelligenceDeepDiveIsEnabled]);

  const dataIntelligenceDeepDiveFilterSetName = useMemo(
    () =>
      stagingToolsDefinition?.dataIntelligenceDeepDiveDefinition
        ?.filterSetName ?? FILTER_SET_DEFAULT_NAME,
    [stagingToolsDefinition],
  );

  const binScatterMultiSelectFilterSetName = useMemo(
    () =>
      stagingToolsDefinition?.binScatterMultiSelectDefinition?.filterSetName ??
      FILTER_SET_DEFAULT_NAME,
    [stagingToolsDefinition],
  );

  return (
    <Spacing direction={'vertical'} size={'md'}>
      <S2Typography
        variant={'headline-4'}
        translatedContent={language.editFocusAreaTools({ focusArea })}
      />

      {dataIntelligenceDeepDiveIsEnabled ? (
        <SelectBoxWithSearch
          type="single"
          selected={dataIntelligenceDeepDiveFilterSetName}
          setSelected={(newFilterSetName: string) => {
            setStagingToolsDefinition({
              ...stagingToolsDefinition,
              dataIntelligenceDeepDiveDefinition: {
                filterSetName: newFilterSetName,
              },
            });
          }}
          list={getListItemsForAllFilterSets({
            filterSets,
            currentFilterSetName: dataIntelligenceDeepDiveFilterSetName,
          })}
          label={'Data Intelligence Deep Dive Filter Set'}
        />
      ) : (
        <S2Typography
          variant={'body-6'}
          translatedContent={language.dataIntelligenceDeepDiveDisabled()}
        />
      )}

      <SelectBoxWithSearch
        type="single"
        selected={binScatterMultiSelectFilterSetName}
        setSelected={(newFilterSetName: string) => {
          setStagingToolsDefinition({
            ...stagingToolsDefinition,
            binScatterMultiSelectDefinition: {
              filterSetName: newFilterSetName,
            },
          });
        }}
        list={getListItemsForAllFilterSets({
          filterSets,
          currentFilterSetName: binScatterMultiSelectFilterSetName,
        })}
        label={'Bin Scatter Multi Select Filter Set'}
      />

      <FocusAreaToolsPreviewValidationErrors
        validationErrors={validationErrors}
      />

      <Spacing direction={'horizontal'} size={'md'}>
        <Button
          behavior={{
            type: 'onClick',
            onClick: onBack,
          }}
          text={'Cancel'}
        />

        <Button
          behavior={{
            type: 'onClick',
            onClick: () => {
              if (stagingToolsDefinition) {
                onSave(stagingToolsDefinition);
              }
            },
          }}
          disabled={validationErrors.length > 0}
          text={'Save Tools'}
        />
      </Spacing>
    </Spacing>
  );
};

export const HiringNotificationSenderConfiguration: React.FC<{
  sendHiringNotificationSummaryEmailAfterTopLevelAnalysis: boolean | undefined;
  setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis: Setter<
    boolean | undefined
  >;
  forceHiringNotificationSummaryToOnlySendToThisEmail: string | undefined;
  setForceHiringNotificationSummaryToOnlySendToThisEmail: Setter<
    string | undefined
  >;
  additionalEmailsToSendAllHiringNotificationSummaryEmailsTo:
    | string[]
    | undefined;
  setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo: Setter<
    string[] | undefined
  >;
  minReadinessRatingForHiringNotificationSummaryEmail: number | undefined;
  setMinReadinessRatingForHiringNotificationSummaryEmail: Setter<
    number | undefined
  >;
  numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail:
    | number
    | undefined;
  setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail: Setter<
    number | undefined
  >;
  enableAtsWriteBack: boolean | undefined;
  setEnableAtsWriteBack: Setter<boolean | undefined>;
  hiringNotificationEmailSubjectSuffixTemplate: HiringNotificationEmailSubjectSuffixTemplate;
  setHiringNotificationEmailSubjectSuffixTemplate: Setter<HiringNotificationEmailSubjectSuffixTemplate>;
}> = ({
  sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
  setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
  forceHiringNotificationSummaryToOnlySendToThisEmail,
  setForceHiringNotificationSummaryToOnlySendToThisEmail,
  additionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
  setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo,
  minReadinessRatingForHiringNotificationSummaryEmail,
  setMinReadinessRatingForHiringNotificationSummaryEmail,
  numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
  setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail,
  hiringNotificationEmailSubjectSuffixTemplate,
  setHiringNotificationEmailSubjectSuffixTemplate,
  enableAtsWriteBack,
  setEnableAtsWriteBack,
}) => {
  return (
    <div>
      <S2Checkbox
        checked={!!sendHiringNotificationSummaryEmailAfterTopLevelAnalysis}
        disabled={false}
        onChange={() => {
          setSendHiringNotificationSummaryEmailAfterTopLevelAnalysis(
            !sendHiringNotificationSummaryEmailAfterTopLevelAnalysis,
          );
        }}
      >
        Send hiring notification summary email after top level analysis
      </S2Checkbox>
      {sendHiringNotificationSummaryEmailAfterTopLevelAnalysis && (
        <div data-testid="hiring-notification-sender-form">
          <Spacing direction="horizontal" size="md" className="items-end">
            <label className="space-x-1 flex flex-col">
              <span>
                Force hiring notification summary to only send to this email
              </span>

              <span className="text-gray-700">
                IMPORTANT: only use when debugging since this will override the
                manager email
              </span>

              <input
                type="email"
                className="form-input"
                value={forceHiringNotificationSummaryToOnlySendToThisEmail}
                onChange={(e) => {
                  if (e.target.value.trim() === '') {
                    setForceHiringNotificationSummaryToOnlySendToThisEmail(
                      undefined,
                    );

                    return;
                  }

                  setForceHiringNotificationSummaryToOnlySendToThisEmail(
                    e.target.value,
                  );
                }}
              />
            </label>

            <label className="space-x-1 flex flex-col">
              <span>Additional emails to CC</span>

              <span className="text-gray-700">
                Use commas to separate multiple emails, i.e.
                hello@world.com,hola@mundo.com
              </span>

              <textarea
                className="form-textarea"
                rows={2}
                value={
                  additionalEmailsToSendAllHiringNotificationSummaryEmailsTo
                    ? additionalEmailsToSendAllHiringNotificationSummaryEmailsTo.join(
                        ',',
                      )
                    : undefined
                }
                onChange={(e) => {
                  if (e.target.value.trim() === '') {
                    setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo(
                      undefined,
                    );

                    return;
                  }

                  setAdditionalEmailsToSendAllHiringNotificationSummaryEmailsTo(
                    e.target.value.split(','),
                  );
                }}
              />
            </label>

            <label className="space-x-1 flex flex-col">
              <span>
                Number of previous days of applicants for hiring notification
                summary email
              </span>

              <input
                type="number"
                className="form-input"
                value={
                  numPreviousDaysOfApplicantsForHiringNotificationSummaryEmail
                }
                min={1}
                onChange={(e) => {
                  const numericValue = parseInt(e.target.value, 10);

                  if (isNaN(numericValue)) {
                    setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail(
                      undefined,
                    );
                    return;
                  }

                  setNumPreviousDaysOfApplicantsForHiringNotificationSummaryEmail(
                    numericValue,
                  );
                }}
              />
            </label>

            <label className="space-x-1 flex flex-col">
              <span>
                Minimum readiness rating for hiring notification summary email
              </span>

              <input
                type="number"
                className="form-input"
                value={minReadinessRatingForHiringNotificationSummaryEmail}
                min={1}
                onChange={(e) => {
                  const numericValue = parseInt(e.target.value, 10);

                  if (isNaN(numericValue)) {
                    setMinReadinessRatingForHiringNotificationSummaryEmail(
                      undefined,
                    );
                    return;
                  }

                  setMinReadinessRatingForHiringNotificationSummaryEmail(
                    numericValue,
                  );
                }}
              />
            </label>
            <SchemaSelectionComponent
              label="Select Email Subject Suffix"
              possibleValues={HiringNotificationEmailSubjectSuffixTemplate.options.map(
                (allowableOption) => {
                  return {
                    optionKey: allowableOption,
                    optionLabel: allowableOption,
                    optionValue: allowableOption,
                  };
                },
              )}
              selectedValueKey={hiringNotificationEmailSubjectSuffixTemplate}
              setSelectedValue={(value) => {
                const safeVal =
                  HiringNotificationEmailSubjectSuffixTemplate.safeParse(value);
                setHiringNotificationEmailSubjectSuffixTemplate(
                  safeVal.success
                    ? safeVal.data
                    : HiringNotificationEmailSubjectSuffixTemplate.Values
                        .NoSuffix,
                );
              }}
            />
            <S2Checkbox
              checked={!!enableAtsWriteBack}
              disabled={false}
              onChange={() => {
                setEnableAtsWriteBack(!enableAtsWriteBack);
              }}
            >
              Enable ATS Write Back
            </S2Checkbox>
          </Spacing>
        </div>
      )}
    </div>
  );
};

const AttributesColumn = ({
  columnHeaderValue,
  uniqueValuesByColumn,
  numericColumns,
  dateColumns,
}: {
  columnHeaderValue: string;
  uniqueValuesByColumn: TransformInsights['uniqueValuesByColumn'];
  numericColumns: TransformInsights['numericColumns'];
  dateColumns: TransformInsights['dateColumns'];
}) => {
  const uniqueValues =
    uniqueValuesByColumn.find(
      (uniqueValues) => uniqueValues.columnName === columnHeaderValue,
    )?.uniqueValues ?? [];

  const allowances = checkIfColumnIsAllowedToBeFilter({
    dateColumns,
    uniqueValuesByColumn,
    numericColumns,
    column: columnHeaderValue,
  });

  const attributes: string[] = [];
  if (uniqueValues.length > 0) {
    attributes.push(`${uniqueValues.length} uniques`);
  }

  if (allowances.allowedDisplayTypes.includes('range_date')) {
    attributes.push('date range');
  }

  if (allowances.allowedDisplayTypes.includes('range_scalar')) {
    const numericInfo = numericColumns?.[columnHeaderValue];

    attributes.push(
      `scalar range, min: ${numericInfo?.minValue ?? 0}, max: ${numericInfo?.maxValue ?? 0}, int?: (${numericInfo?.isInteger ? 'yes' : 'no'})`,
    );
  }

  return <div>{attributes.join(', ')}</div>;
};
